// @generated
// This file was automatically generated and should not be edited.
// Run `dev generate pipeline-frontend` to regenerate.

/* eslint-disable unused-imports/no-unused-imports */

// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {ColumnTypeValidationFlag} from 'data-frames/util/validateColumnType';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {LeafType} from 'data-types/benchling-type-def/BenchlingTypeDef';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {PipelineStepDataKind, PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {PipelineStepShape} from 'pipelines/StepShapeUtils';

export const LAYOUT_STEP_SHAPES = [
  {
    stepType: PipelineStepType.LAYOUT,
    isDeprecated: false,
    version: 0,
    inputDataShapes: {
      'Input datasets': {
        systemName: 'Input datasets',
        displayName: 'Input datasets',
        kind: PipelineStepDataKind.DATASET,
        isMulti: true,
        isRequired: false
      },
      'Input files': {
        systemName: 'Input files',
        displayName: 'Input files',
        kind: PipelineStepDataKind.FILE,
        isMulti: true,
        isRequired: false
      },
      'Input charts': {
        systemName: 'Input charts',
        displayName: 'Input charts',
        kind: PipelineStepDataKind.CHART,
        isMulti: true,
        isRequired: false
      }
    },
    outputDataShapes: {},
    config: {
      name: {
        kind: 'string',
        required: true
      },
      icon: {
        kind: 'string',
        required: false
      },
      sections: {
        kind: 'array',
        required: true,
        elementSpec: {
          kind: 'taggedUnion',
          required: true,
          tagKey: 'type',
          choices: [
            {
              kind: 'shape',
              required: true,
              fields: {
                type: {
                  kind: 'string',
                  required: true,
                  value: 'GRID'
                },
                gridMode: {
                  kind: 'enum',
                  required: false,
                  choices: [
                    'SEPARATED',
                    'COMBINED'
                  ]
                },
                title: {
                  kind: 'string',
                  required: false
                },
                rows: {
                  kind: 'array',
                  required: true,
                  elementSpec: {
                    kind: 'array',
                    required: true,
                    elementSpec: {
                      kind: 'taggedUnion',
                      required: true,
                      tagKey: 'type',
                      choices: [
                        {
                          kind: 'shape',
                          required: true,
                          fields: {
                            type: {
                              kind: 'string',
                              required: true,
                              value: 'DATA'
                            },
                            inputReference: {
                              kind: 'shape',
                              required: true,
                              fields: {
                                inputDataName: {
                                  kind: 'enum',
                                  required: true,
                                  choices: [
                                    'Input datasets',
                                    'Input charts',
                                    'Input files'
                                  ]
                                },
                                inputDataIndex: {
                                  kind: 'integer',
                                  required: true
                                }
                              }
                            },
                            blockConfig: {
                              kind: 'taggedUnion',
                              required: false,
                              tagKey: 'blockMode',
                              choices: [
                                {
                                  kind: 'shape',
                                  required: true,
                                  fields: {
                                    blockMode: {
                                      kind: 'string',
                                      required: true,
                                      value: 'PANE'
                                    },
                                    title: {
                                      kind: 'string',
                                      required: false
                                    },
                                    subtitle: {
                                      kind: 'string',
                                      required: false
                                    },
                                    infoText: {
                                      kind: 'string',
                                      required: false
                                    },
                                    isCollapsible: {
                                      kind: 'boolean',
                                      required: false
                                    }
                                  }
                                },
                                {
                                  kind: 'shape',
                                  required: true,
                                  fields: {
                                    blockMode: {
                                      kind: 'string',
                                      required: true,
                                      value: 'CONTENT_ONLY'
                                    },
                                    isCollapsible: {
                                      kind: 'boolean',
                                      required: false
                                    }
                                  }
                                }
                              ]
                            },
                            tableConfig: {
                              kind: 'shape',
                              required: false,
                              fields: {
                                tableMode: {
                                  kind: 'enum',
                                  required: false,
                                  choices: [
                                    'TEXT',
                                    'RICH'
                                  ]
                                }
                              }
                            }
                          }
                        },
                        {
                          kind: 'shape',
                          required: true,
                          fields: {
                            type: {
                              kind: 'string',
                              required: true,
                              value: 'CONFIG_FORM'
                            },
                            blockConfig: {
                              kind: 'taggedUnion',
                              required: false,
                              tagKey: 'blockMode',
                              choices: [
                                {
                                  kind: 'shape',
                                  required: true,
                                  fields: {
                                    blockMode: {
                                      kind: 'string',
                                      required: true,
                                      value: 'PANE'
                                    },
                                    title: {
                                      kind: 'string',
                                      required: false
                                    },
                                    subtitle: {
                                      kind: 'string',
                                      required: false
                                    },
                                    infoText: {
                                      kind: 'string',
                                      required: false
                                    },
                                    isCollapsible: {
                                      kind: 'boolean',
                                      required: false
                                    }
                                  }
                                },
                                {
                                  kind: 'shape',
                                  required: true,
                                  fields: {
                                    blockMode: {
                                      kind: 'string',
                                      required: true,
                                      value: 'CONTENT_ONLY'
                                    },
                                    isCollapsible: {
                                      kind: 'boolean',
                                      required: false
                                    }
                                  }
                                }
                              ]
                            },
                            configFields: {
                              kind: 'array',
                              required: true,
                              elementSpec: {
                                kind: 'shape',
                                required: true,
                                fields: {
                                  key: {
                                    kind: 'string',
                                    required: true
                                  },
                                  configReferences: {
                                    kind: 'array',
                                    required: true,
                                    elementSpec: {
                                      kind: 'shape',
                                      required: true,
                                      fields: {
                                        inputDataName: {
                                          kind: 'enum',
                                          required: true,
                                          choices: [
                                            'Input datasets',
                                            'Input charts',
                                            'Input files'
                                          ]
                                        },
                                        inputDataIndex: {
                                          kind: 'integer',
                                          required: true
                                        },
                                        configPath: {
                                          kind: 'array',
                                          required: true,
                                          elementSpec: {
                                            kind: 'anything',
                                            required: true
                                          }
                                        }
                                      }
                                    },
                                    minItems: 1
                                  },
                                  configSpec: {
                                    kind: 'taggedUnion',
                                    required: true,
                                    tagKey: 'kind',
                                    choices: [
                                      {
                                        kind: 'shape',
                                        required: true,
                                        fields: {
                                          kind: {
                                            kind: 'string',
                                            required: true,
                                            value: 'boolean'
                                          },
                                          required: {
                                            kind: 'boolean',
                                            required: true
                                          }
                                        }
                                      },
                                      {
                                        kind: 'shape',
                                        required: true,
                                        fields: {
                                          kind: {
                                            kind: 'string',
                                            required: true,
                                            value: 'columnReference'
                                          },
                                          inputDataName: {
                                            kind: 'string',
                                            required: true
                                          },
                                          validationOptions: {
                                            kind: 'shape',
                                            required: false,
                                            fields: {
                                              allowedLeafTypes: {
                                                kind: 'array',
                                                required: false,
                                                elementSpec: {
                                                  kind: 'enum',
                                                  required: true,
                                                  choices: [
                                                    'BOOLEAN',
                                                    'DATETIME',
                                                    'DATE',
                                                    'DECIMAL',
                                                    'INTEGER',
                                                    'JSON',
                                                    'TEXT',
                                                    'BENCHLING_OBJECT',
                                                    'BLOB',
                                                    'CHART',
                                                    'FILE',
                                                    'SCRATCH_FILE',
                                                    'DATA_FRAME',
                                                    'DATASET',
                                                    'DROPDOWN_OPTION',
                                                    'BATCH',
                                                    'BIOENTITY',
                                                    'BASIC_FOLDER_ITEM',
                                                    'MIXTURE',
                                                    'MOLECULE',
                                                    'PROTEIN',
                                                    'SEQUENCE',
                                                    'ENTRY',
                                                    'PROTOCOL',
                                                    'REQUEST',
                                                    'RESULT',
                                                    'RUN',
                                                    'STORABLE',
                                                    'BOX',
                                                    'CONTAINER',
                                                    'LOCATION',
                                                    'PLATE',
                                                    'PROCESS',
                                                    'PROCESS_TASK',
                                                    'PROCESS_OUTPUT',
                                                    'STUDY',
                                                    'TEAM',
                                                    'TEST_ORDER',
                                                    'USER'
                                                  ]
                                                }
                                              },
                                              listType: {
                                                kind: 'enum',
                                                required: false,
                                                choices: [
                                                  'ALLOWED',
                                                  'REQUIRED',
                                                  'NOT_ALLOWED'
                                                ]
                                              },
                                              nullableType: {
                                                kind: 'enum',
                                                required: false,
                                                choices: [
                                                  'ALLOWED',
                                                  'REQUIRED',
                                                  'NOT_ALLOWED'
                                                ]
                                              }
                                            }
                                          },
                                          required: {
                                            kind: 'boolean',
                                            required: true
                                          }
                                        }
                                      },
                                      {
                                        kind: 'shape',
                                        required: true,
                                        fields: {
                                          kind: {
                                            kind: 'string',
                                            required: true,
                                            value: 'columnValue'
                                          },
                                          columnSystemName: {
                                            kind: 'string',
                                            required: true
                                          },
                                          inputDataName: {
                                            kind: 'string',
                                            required: true
                                          },
                                          inputDataIndex: {
                                            kind: 'integer',
                                            required: true
                                          },
                                          required: {
                                            kind: 'boolean',
                                            required: true
                                          }
                                        }
                                      },
                                      {
                                        kind: 'shape',
                                        required: true,
                                        fields: {
                                          kind: {
                                            kind: 'string',
                                            required: true,
                                            value: 'date'
                                          },
                                          required: {
                                            kind: 'boolean',
                                            required: true
                                          }
                                        }
                                      },
                                      {
                                        kind: 'shape',
                                        required: true,
                                        fields: {
                                          kind: {
                                            kind: 'string',
                                            required: true,
                                            value: 'enum'
                                          },
                                          choices: {
                                            kind: 'array',
                                            required: true,
                                            elementSpec: {
                                              kind: 'string',
                                              required: true
                                            }
                                          },
                                          required: {
                                            kind: 'boolean',
                                            required: true
                                          }
                                        }
                                      },
                                      {
                                        kind: 'shape',
                                        required: true,
                                        fields: {
                                          kind: {
                                            kind: 'string',
                                            required: true,
                                            value: 'integer'
                                          },
                                          minValue: {
                                            kind: 'integer',
                                            required: false
                                          },
                                          maxValue: {
                                            kind: 'integer',
                                            required: false
                                          },
                                          required: {
                                            kind: 'boolean',
                                            required: true
                                          }
                                        }
                                      },
                                      {
                                        kind: 'shape',
                                        required: true,
                                        fields: {
                                          kind: {
                                            kind: 'string',
                                            required: true,
                                            value: 'number'
                                          },
                                          required: {
                                            kind: 'boolean',
                                            required: true
                                          }
                                        }
                                      },
                                      {
                                        kind: 'shape',
                                        required: true,
                                        fields: {
                                          kind: {
                                            kind: 'string',
                                            required: true,
                                            value: 'string'
                                          },
                                          value: {
                                            kind: 'string',
                                            required: false
                                          },
                                          pattern: {
                                            kind: 'string',
                                            required: false
                                          },
                                          required: {
                                            kind: 'boolean',
                                            required: true
                                          }
                                        }
                                      },
                                      {
                                        kind: 'shape',
                                        required: true,
                                        fields: {
                                          kind: {
                                            kind: 'string',
                                            required: true,
                                            value: 'tableReference'
                                          },
                                          inputDataName: {
                                            kind: 'string',
                                            required: true
                                          },
                                          inputDataIndex: {
                                            kind: 'integer',
                                            required: true
                                          },
                                          required: {
                                            kind: 'boolean',
                                            required: true
                                          }
                                        }
                                      }
                                    ]
                                  }
                                }
                              }
                            },
                            uiSchema: {
                              kind: 'shape',
                              required: true,
                              fields: {
                                type: {
                                  kind: 'string',
                                  required: true,
                                  value: 'SHAPE'
                                },
                                sectionName: {
                                  kind: 'string',
                                  required: false
                                },
                                showDividerLine: {
                                  kind: 'boolean',
                                  required: false
                                },
                                conditional: {
                                  kind: 'shape',
                                  required: false,
                                  fields: {
                                    tagValue: {
                                      kind: 'string',
                                      required: true
                                    },
                                    configShapePath: {
                                      kind: 'array',
                                      required: true,
                                      elementSpec: {
                                        kind: 'string',
                                        required: true
                                      }
                                    }
                                  }
                                },
                                infoText: {
                                  kind: 'string',
                                  required: false
                                },
                                isCollapsible: {
                                  kind: 'boolean',
                                  required: false
                                },
                                numColumns: {
                                  kind: 'integer',
                                  required: false
                                },
                                fields: {
                                  kind: 'array',
                                  required: true,
                                  elementSpec: {
                                    kind: 'shape',
                                    required: true,
                                    fields: {
                                      key: {
                                        kind: 'string',
                                        required: true
                                      },
                                      uiSchema: {
                                        kind: 'taggedUnion',
                                        required: true,
                                        tagKey: 'type',
                                        choices: [
                                          {
                                            kind: 'shape',
                                            required: true,
                                            fields: {
                                              type: {
                                                kind: 'string',
                                                required: true,
                                                value: 'FIELD'
                                              },
                                              displayName: {
                                                kind: 'string',
                                                required: false
                                              },
                                              editorOverride: {
                                                kind: 'enum',
                                                required: false,
                                                choices: [
                                                  'CHECKBOX',
                                                  'ICON_SELECTOR',
                                                  'DATE_RANGE'
                                                ]
                                              },
                                              infoText: {
                                                kind: 'string',
                                                required: false
                                              },
                                              fieldSettings: {
                                                kind: 'taggedUnion',
                                                required: false,
                                                tagKey: 'type',
                                                choices: [
                                                  {
                                                    kind: 'shape',
                                                    required: true,
                                                    fields: {
                                                      type: {
                                                        kind: 'string',
                                                        required: true,
                                                        value: 'CHECKBOX_SETTINGS'
                                                      },
                                                      checkboxLabel: {
                                                        kind: 'string',
                                                        required: true
                                                      }
                                                    }
                                                  },
                                                  {
                                                    kind: 'shape',
                                                    required: true,
                                                    fields: {
                                                      type: {
                                                        kind: 'string',
                                                        required: true,
                                                        value: 'COLUMN_REFERENCE_SETTINGS'
                                                      },
                                                      noColumnSelectedText: {
                                                        kind: 'string',
                                                        required: false
                                                      },
                                                      allowSelectNull: {
                                                        kind: 'boolean',
                                                        required: false
                                                      },
                                                      systemNameWildcardSelector: {
                                                        kind: 'string',
                                                        required: false
                                                      },
                                                      renderCyclingSelector: {
                                                        kind: 'boolean',
                                                        required: false
                                                      }
                                                    }
                                                  },
                                                  {
                                                    kind: 'shape',
                                                    required: true,
                                                    fields: {
                                                      type: {
                                                        kind: 'string',
                                                        required: true,
                                                        value: 'COLUMN_VALUE_SETTINGS'
                                                      },
                                                      noValueSelectedText: {
                                                        kind: 'string',
                                                        required: false
                                                      },
                                                      renderCyclingSelector: {
                                                        kind: 'boolean',
                                                        required: false
                                                      }
                                                    }
                                                  },
                                                  {
                                                    kind: 'shape',
                                                    required: true,
                                                    fields: {
                                                      type: {
                                                        kind: 'string',
                                                        required: true,
                                                        value: 'RANGE_SETTINGS'
                                                      },
                                                      startKey: {
                                                        kind: 'string',
                                                        required: true
                                                      },
                                                      endKey: {
                                                        kind: 'string',
                                                        required: true
                                                      }
                                                    }
                                                  },
                                                  {
                                                    kind: 'shape',
                                                    required: true,
                                                    fields: {
                                                      type: {
                                                        kind: 'string',
                                                        required: true,
                                                        value: 'ENUM_SETTINGS'
                                                      },
                                                      displayNames: {
                                                        kind: 'array',
                                                        required: false,
                                                        elementSpec: {
                                                          kind: 'shape',
                                                          required: true,
                                                          fields: {
                                                            value: {
                                                              kind: 'string',
                                                              required: true
                                                            },
                                                            displayName: {
                                                              kind: 'string',
                                                              required: true
                                                            }
                                                          }
                                                        }
                                                      },
                                                      renderCyclingSelector: {
                                                        kind: 'boolean',
                                                        required: false
                                                      }
                                                    }
                                                  },
                                                  {
                                                    kind: 'shape',
                                                    required: true,
                                                    fields: {
                                                      type: {
                                                        kind: 'string',
                                                        required: true,
                                                        value: 'ICON_SELECTOR_SETTINGS'
                                                      },
                                                      iconNames: {
                                                        kind: 'array',
                                                        required: false,
                                                        elementSpec: {
                                                          kind: 'shape',
                                                          required: true,
                                                          fields: {
                                                            value: {
                                                              kind: 'string',
                                                              required: true
                                                            },
                                                            iconName: {
                                                              kind: 'string',
                                                              required: true
                                                            }
                                                          }
                                                        }
                                                      },
                                                      displayNames: {
                                                        kind: 'array',
                                                        required: false,
                                                        elementSpec: {
                                                          kind: 'shape',
                                                          required: true,
                                                          fields: {
                                                            value: {
                                                              kind: 'string',
                                                              required: true
                                                            },
                                                            displayName: {
                                                              kind: 'string',
                                                              required: true
                                                            }
                                                          }
                                                        }
                                                      },
                                                      defaultValue: {
                                                        kind: 'string',
                                                        required: false
                                                      }
                                                    }
                                                  },
                                                  {
                                                    kind: 'shape',
                                                    required: true,
                                                    fields: {
                                                      type: {
                                                        kind: 'string',
                                                        required: true,
                                                        value: 'TABLE_REFERENCE_SETTINGS'
                                                      },
                                                      disabledColumn: {
                                                        kind: 'array',
                                                        required: false,
                                                        elementSpec: {
                                                          kind: 'string',
                                                          required: true
                                                        }
                                                      },
                                                      hiddenColumn: {
                                                        kind: 'array',
                                                        required: false,
                                                        elementSpec: {
                                                          kind: 'string',
                                                          required: true
                                                        }
                                                      }
                                                    }
                                                  },
                                                  {
                                                    kind: 'shape',
                                                    required: true,
                                                    fields: {
                                                      type: {
                                                        kind: 'string',
                                                        required: true,
                                                        value: 'TAGGED_UNION_SETTINGS'
                                                      },
                                                      tagKeyDisplayNames: {
                                                        kind: 'array',
                                                        required: false,
                                                        elementSpec: {
                                                          kind: 'shape',
                                                          required: true,
                                                          fields: {
                                                            value: {
                                                              kind: 'string',
                                                              required: true
                                                            },
                                                            displayName: {
                                                              kind: 'string',
                                                              required: true
                                                            }
                                                          }
                                                        }
                                                      },
                                                      renderCyclingSelector: {
                                                        kind: 'boolean',
                                                        required: false
                                                      }
                                                    }
                                                  },
                                                  {
                                                    kind: 'shape',
                                                    required: true,
                                                    fields: {
                                                      type: {
                                                        kind: 'string',
                                                        required: true,
                                                        value: 'STRING_FIELD_SETTINGS'
                                                      },
                                                      useTextArea: {
                                                        kind: 'boolean',
                                                        required: false
                                                      }
                                                    }
                                                  }
                                                ]
                                              }
                                            }
                                          },
                                          {
                                            kind: 'shape',
                                            required: true,
                                            fields: {
                                              type: {
                                                kind: 'string',
                                                required: true,
                                                value: 'ACTION_BUTTON'
                                              },
                                              action: {
                                                kind: 'enum',
                                                required: true,
                                                choices: [
                                                  'RESET',
                                                  'SUBMIT'
                                                ]
                                              },
                                              buttonText: {
                                                kind: 'string',
                                                required: true
                                              },
                                              buttonIcon: {
                                                kind: 'string',
                                                required: false
                                              },
                                              buttonVariant: {
                                                kind: 'enum',
                                                required: false,
                                                choices: [
                                                  'primary',
                                                  'secondary'
                                                ]
                                              },
                                              helpText: {
                                                kind: 'string',
                                                required: false
                                              }
                                            }
                                          },
                                          {
                                            kind: 'shape',
                                            required: true,
                                            fields: {
                                              type: {
                                                kind: 'string',
                                                required: true,
                                                value: 'MARKDOWN'
                                              },
                                              markdown: {
                                                kind: 'string',
                                                required: true
                                              }
                                            }
                                          },
                                          {
                                            kind: 'shape',
                                            required: true,
                                            fields: {
                                              type: {
                                                kind: 'string',
                                                required: true,
                                                value: 'SHAPE'
                                              },
                                              sectionName: {
                                                kind: 'string',
                                                required: false
                                              },
                                              showDividerLine: {
                                                kind: 'boolean',
                                                required: false
                                              },
                                              conditional: {
                                                kind: 'shape',
                                                required: false,
                                                fields: {
                                                  tagValue: {
                                                    kind: 'string',
                                                    required: true
                                                  },
                                                  configShapePath: {
                                                    kind: 'array',
                                                    required: true,
                                                    elementSpec: {
                                                      kind: 'string',
                                                      required: true
                                                    }
                                                  }
                                                }
                                              },
                                              infoText: {
                                                kind: 'string',
                                                required: false
                                              },
                                              isCollapsible: {
                                                kind: 'boolean',
                                                required: false
                                              },
                                              numColumns: {
                                                kind: 'integer',
                                                required: false
                                              },
                                              fields: {
                                                kind: 'array',
                                                required: true,
                                                elementSpec: {
                                                  kind: 'shape',
                                                  required: true,
                                                  fields: {
                                                    key: {
                                                      kind: 'string',
                                                      required: true
                                                    },
                                                    uiSchema: {
                                                      kind: 'taggedUnion',
                                                      required: true,
                                                      tagKey: 'type',
                                                      choices: [
                                                        {
                                                          kind: 'shape',
                                                          required: true,
                                                          fields: {
                                                            type: {
                                                              kind: 'string',
                                                              required: true,
                                                              value: 'FIELD'
                                                            },
                                                            displayName: {
                                                              kind: 'string',
                                                              required: false
                                                            },
                                                            editorOverride: {
                                                              kind: 'enum',
                                                              required: false,
                                                              choices: [
                                                                'CHECKBOX',
                                                                'ICON_SELECTOR',
                                                                'DATE_RANGE'
                                                              ]
                                                            },
                                                            infoText: {
                                                              kind: 'string',
                                                              required: false
                                                            },
                                                            fieldSettings: {
                                                              kind: 'taggedUnion',
                                                              required: false,
                                                              tagKey: 'type',
                                                              choices: [
                                                                {
                                                                  kind: 'shape',
                                                                  required: true,
                                                                  fields: {
                                                                    type: {
                                                                      kind: 'string',
                                                                      required: true,
                                                                      value: 'CHECKBOX_SETTINGS'
                                                                    },
                                                                    checkboxLabel: {
                                                                      kind: 'string',
                                                                      required: true
                                                                    }
                                                                  }
                                                                },
                                                                {
                                                                  kind: 'shape',
                                                                  required: true,
                                                                  fields: {
                                                                    type: {
                                                                      kind: 'string',
                                                                      required: true,
                                                                      value: 'COLUMN_REFERENCE_SETTINGS'
                                                                    },
                                                                    noColumnSelectedText: {
                                                                      kind: 'string',
                                                                      required: false
                                                                    },
                                                                    allowSelectNull: {
                                                                      kind: 'boolean',
                                                                      required: false
                                                                    },
                                                                    systemNameWildcardSelector: {
                                                                      kind: 'string',
                                                                      required: false
                                                                    },
                                                                    renderCyclingSelector: {
                                                                      kind: 'boolean',
                                                                      required: false
                                                                    }
                                                                  }
                                                                },
                                                                {
                                                                  kind: 'shape',
                                                                  required: true,
                                                                  fields: {
                                                                    type: {
                                                                      kind: 'string',
                                                                      required: true,
                                                                      value: 'COLUMN_VALUE_SETTINGS'
                                                                    },
                                                                    noValueSelectedText: {
                                                                      kind: 'string',
                                                                      required: false
                                                                    },
                                                                    renderCyclingSelector: {
                                                                      kind: 'boolean',
                                                                      required: false
                                                                    }
                                                                  }
                                                                },
                                                                {
                                                                  kind: 'shape',
                                                                  required: true,
                                                                  fields: {
                                                                    type: {
                                                                      kind: 'string',
                                                                      required: true,
                                                                      value: 'RANGE_SETTINGS'
                                                                    },
                                                                    startKey: {
                                                                      kind: 'string',
                                                                      required: true
                                                                    },
                                                                    endKey: {
                                                                      kind: 'string',
                                                                      required: true
                                                                    }
                                                                  }
                                                                },
                                                                {
                                                                  kind: 'shape',
                                                                  required: true,
                                                                  fields: {
                                                                    type: {
                                                                      kind: 'string',
                                                                      required: true,
                                                                      value: 'ENUM_SETTINGS'
                                                                    },
                                                                    displayNames: {
                                                                      kind: 'array',
                                                                      required: false,
                                                                      elementSpec: {
                                                                        kind: 'shape',
                                                                        required: true,
                                                                        fields: {
                                                                          value: {
                                                                            kind: 'string',
                                                                            required: true
                                                                          },
                                                                          displayName: {
                                                                            kind: 'string',
                                                                            required: true
                                                                          }
                                                                        }
                                                                      }
                                                                    },
                                                                    renderCyclingSelector: {
                                                                      kind: 'boolean',
                                                                      required: false
                                                                    }
                                                                  }
                                                                },
                                                                {
                                                                  kind: 'shape',
                                                                  required: true,
                                                                  fields: {
                                                                    type: {
                                                                      kind: 'string',
                                                                      required: true,
                                                                      value: 'ICON_SELECTOR_SETTINGS'
                                                                    },
                                                                    iconNames: {
                                                                      kind: 'array',
                                                                      required: false,
                                                                      elementSpec: {
                                                                        kind: 'shape',
                                                                        required: true,
                                                                        fields: {
                                                                          value: {
                                                                            kind: 'string',
                                                                            required: true
                                                                          },
                                                                          iconName: {
                                                                            kind: 'string',
                                                                            required: true
                                                                          }
                                                                        }
                                                                      }
                                                                    },
                                                                    displayNames: {
                                                                      kind: 'array',
                                                                      required: false,
                                                                      elementSpec: {
                                                                        kind: 'shape',
                                                                        required: true,
                                                                        fields: {
                                                                          value: {
                                                                            kind: 'string',
                                                                            required: true
                                                                          },
                                                                          displayName: {
                                                                            kind: 'string',
                                                                            required: true
                                                                          }
                                                                        }
                                                                      }
                                                                    },
                                                                    defaultValue: {
                                                                      kind: 'string',
                                                                      required: false
                                                                    }
                                                                  }
                                                                },
                                                                {
                                                                  kind: 'shape',
                                                                  required: true,
                                                                  fields: {
                                                                    type: {
                                                                      kind: 'string',
                                                                      required: true,
                                                                      value: 'TABLE_REFERENCE_SETTINGS'
                                                                    },
                                                                    disabledColumn: {
                                                                      kind: 'array',
                                                                      required: false,
                                                                      elementSpec: {
                                                                        kind: 'string',
                                                                        required: true
                                                                      }
                                                                    },
                                                                    hiddenColumn: {
                                                                      kind: 'array',
                                                                      required: false,
                                                                      elementSpec: {
                                                                        kind: 'string',
                                                                        required: true
                                                                      }
                                                                    }
                                                                  }
                                                                },
                                                                {
                                                                  kind: 'shape',
                                                                  required: true,
                                                                  fields: {
                                                                    type: {
                                                                      kind: 'string',
                                                                      required: true,
                                                                      value: 'TAGGED_UNION_SETTINGS'
                                                                    },
                                                                    tagKeyDisplayNames: {
                                                                      kind: 'array',
                                                                      required: false,
                                                                      elementSpec: {
                                                                        kind: 'shape',
                                                                        required: true,
                                                                        fields: {
                                                                          value: {
                                                                            kind: 'string',
                                                                            required: true
                                                                          },
                                                                          displayName: {
                                                                            kind: 'string',
                                                                            required: true
                                                                          }
                                                                        }
                                                                      }
                                                                    },
                                                                    renderCyclingSelector: {
                                                                      kind: 'boolean',
                                                                      required: false
                                                                    }
                                                                  }
                                                                },
                                                                {
                                                                  kind: 'shape',
                                                                  required: true,
                                                                  fields: {
                                                                    type: {
                                                                      kind: 'string',
                                                                      required: true,
                                                                      value: 'STRING_FIELD_SETTINGS'
                                                                    },
                                                                    useTextArea: {
                                                                      kind: 'boolean',
                                                                      required: false
                                                                    }
                                                                  }
                                                                }
                                                              ]
                                                            }
                                                          }
                                                        },
                                                        {
                                                          kind: 'shape',
                                                          required: true,
                                                          fields: {
                                                            type: {
                                                              kind: 'string',
                                                              required: true,
                                                              value: 'ACTION_BUTTON'
                                                            },
                                                            action: {
                                                              kind: 'enum',
                                                              required: true,
                                                              choices: [
                                                                'RESET',
                                                                'SUBMIT'
                                                              ]
                                                            },
                                                            buttonText: {
                                                              kind: 'string',
                                                              required: true
                                                            },
                                                            buttonIcon: {
                                                              kind: 'string',
                                                              required: false
                                                            },
                                                            buttonVariant: {
                                                              kind: 'enum',
                                                              required: false,
                                                              choices: [
                                                                'primary',
                                                                'secondary'
                                                              ]
                                                            },
                                                            helpText: {
                                                              kind: 'string',
                                                              required: false
                                                            }
                                                          }
                                                        },
                                                        {
                                                          kind: 'shape',
                                                          required: true,
                                                          fields: {
                                                            type: {
                                                              kind: 'string',
                                                              required: true,
                                                              value: 'MARKDOWN'
                                                            },
                                                            markdown: {
                                                              kind: 'string',
                                                              required: true
                                                            }
                                                          }
                                                        }
                                                      ]
                                                    }
                                                  }
                                                },
                                                minItems: 1
                                              }
                                            }
                                          }
                                        ]
                                      }
                                    }
                                  },
                                  minItems: 1
                                }
                              }
                            }
                          }
                        },
                        {
                          kind: 'shape',
                          required: true,
                          fields: {
                            type: {
                              kind: 'string',
                              required: true,
                              value: 'MARKDOWN'
                            },
                            markdown: {
                              kind: 'string',
                              required: true
                            },
                            blockConfig: {
                              kind: 'taggedUnion',
                              required: false,
                              tagKey: 'blockMode',
                              choices: [
                                {
                                  kind: 'shape',
                                  required: true,
                                  fields: {
                                    blockMode: {
                                      kind: 'string',
                                      required: true,
                                      value: 'PANE'
                                    },
                                    title: {
                                      kind: 'string',
                                      required: false
                                    },
                                    subtitle: {
                                      kind: 'string',
                                      required: false
                                    },
                                    infoText: {
                                      kind: 'string',
                                      required: false
                                    },
                                    isCollapsible: {
                                      kind: 'boolean',
                                      required: false
                                    }
                                  }
                                },
                                {
                                  kind: 'shape',
                                  required: true,
                                  fields: {
                                    blockMode: {
                                      kind: 'string',
                                      required: true,
                                      value: 'CONTENT_ONLY'
                                    },
                                    isCollapsible: {
                                      kind: 'boolean',
                                      required: false
                                    }
                                  }
                                }
                              ]
                            }
                          }
                        },
                        {
                          kind: 'shape',
                          required: true,
                          fields: {
                            type: {
                              kind: 'string',
                              required: true,
                              value: 'NESTED_GRID'
                            },
                            gridMode: {
                              kind: 'enum',
                              required: false,
                              choices: [
                                'SEPARATED',
                                'COMBINED'
                              ]
                            },
                            rows: {
                              kind: 'array',
                              required: true,
                              elementSpec: {
                                kind: 'array',
                                required: true,
                                elementSpec: {
                                  kind: 'taggedUnion',
                                  required: true,
                                  tagKey: 'type',
                                  choices: [
                                    {
                                      kind: 'shape',
                                      required: true,
                                      fields: {
                                        type: {
                                          kind: 'string',
                                          required: true,
                                          value: 'DATA'
                                        },
                                        inputReference: {
                                          kind: 'shape',
                                          required: true,
                                          fields: {
                                            inputDataName: {
                                              kind: 'enum',
                                              required: true,
                                              choices: [
                                                'Input datasets',
                                                'Input charts',
                                                'Input files'
                                              ]
                                            },
                                            inputDataIndex: {
                                              kind: 'integer',
                                              required: true
                                            }
                                          }
                                        },
                                        blockConfig: {
                                          kind: 'taggedUnion',
                                          required: false,
                                          tagKey: 'blockMode',
                                          choices: [
                                            {
                                              kind: 'shape',
                                              required: true,
                                              fields: {
                                                blockMode: {
                                                  kind: 'string',
                                                  required: true,
                                                  value: 'PANE'
                                                },
                                                title: {
                                                  kind: 'string',
                                                  required: false
                                                },
                                                subtitle: {
                                                  kind: 'string',
                                                  required: false
                                                },
                                                infoText: {
                                                  kind: 'string',
                                                  required: false
                                                },
                                                isCollapsible: {
                                                  kind: 'boolean',
                                                  required: false
                                                }
                                              }
                                            },
                                            {
                                              kind: 'shape',
                                              required: true,
                                              fields: {
                                                blockMode: {
                                                  kind: 'string',
                                                  required: true,
                                                  value: 'CONTENT_ONLY'
                                                },
                                                isCollapsible: {
                                                  kind: 'boolean',
                                                  required: false
                                                }
                                              }
                                            }
                                          ]
                                        },
                                        tableConfig: {
                                          kind: 'shape',
                                          required: false,
                                          fields: {
                                            tableMode: {
                                              kind: 'enum',
                                              required: false,
                                              choices: [
                                                'TEXT',
                                                'RICH'
                                              ]
                                            }
                                          }
                                        }
                                      }
                                    },
                                    {
                                      kind: 'shape',
                                      required: true,
                                      fields: {
                                        type: {
                                          kind: 'string',
                                          required: true,
                                          value: 'CONFIG_FORM'
                                        },
                                        blockConfig: {
                                          kind: 'taggedUnion',
                                          required: false,
                                          tagKey: 'blockMode',
                                          choices: [
                                            {
                                              kind: 'shape',
                                              required: true,
                                              fields: {
                                                blockMode: {
                                                  kind: 'string',
                                                  required: true,
                                                  value: 'PANE'
                                                },
                                                title: {
                                                  kind: 'string',
                                                  required: false
                                                },
                                                subtitle: {
                                                  kind: 'string',
                                                  required: false
                                                },
                                                infoText: {
                                                  kind: 'string',
                                                  required: false
                                                },
                                                isCollapsible: {
                                                  kind: 'boolean',
                                                  required: false
                                                }
                                              }
                                            },
                                            {
                                              kind: 'shape',
                                              required: true,
                                              fields: {
                                                blockMode: {
                                                  kind: 'string',
                                                  required: true,
                                                  value: 'CONTENT_ONLY'
                                                },
                                                isCollapsible: {
                                                  kind: 'boolean',
                                                  required: false
                                                }
                                              }
                                            }
                                          ]
                                        },
                                        configFields: {
                                          kind: 'array',
                                          required: true,
                                          elementSpec: {
                                            kind: 'shape',
                                            required: true,
                                            fields: {
                                              key: {
                                                kind: 'string',
                                                required: true
                                              },
                                              configReferences: {
                                                kind: 'array',
                                                required: true,
                                                elementSpec: {
                                                  kind: 'shape',
                                                  required: true,
                                                  fields: {
                                                    inputDataName: {
                                                      kind: 'enum',
                                                      required: true,
                                                      choices: [
                                                        'Input datasets',
                                                        'Input charts',
                                                        'Input files'
                                                      ]
                                                    },
                                                    inputDataIndex: {
                                                      kind: 'integer',
                                                      required: true
                                                    },
                                                    configPath: {
                                                      kind: 'array',
                                                      required: true,
                                                      elementSpec: {
                                                        kind: 'anything',
                                                        required: true
                                                      }
                                                    }
                                                  }
                                                },
                                                minItems: 1
                                              },
                                              configSpec: {
                                                kind: 'taggedUnion',
                                                required: true,
                                                tagKey: 'kind',
                                                choices: [
                                                  {
                                                    kind: 'shape',
                                                    required: true,
                                                    fields: {
                                                      kind: {
                                                        kind: 'string',
                                                        required: true,
                                                        value: 'boolean'
                                                      },
                                                      required: {
                                                        kind: 'boolean',
                                                        required: true
                                                      }
                                                    }
                                                  },
                                                  {
                                                    kind: 'shape',
                                                    required: true,
                                                    fields: {
                                                      kind: {
                                                        kind: 'string',
                                                        required: true,
                                                        value: 'columnReference'
                                                      },
                                                      inputDataName: {
                                                        kind: 'string',
                                                        required: true
                                                      },
                                                      validationOptions: {
                                                        kind: 'shape',
                                                        required: false,
                                                        fields: {
                                                          allowedLeafTypes: {
                                                            kind: 'array',
                                                            required: false,
                                                            elementSpec: {
                                                              kind: 'enum',
                                                              required: true,
                                                              choices: [
                                                                'BOOLEAN',
                                                                'DATETIME',
                                                                'DATE',
                                                                'DECIMAL',
                                                                'INTEGER',
                                                                'JSON',
                                                                'TEXT',
                                                                'BENCHLING_OBJECT',
                                                                'BLOB',
                                                                'CHART',
                                                                'FILE',
                                                                'SCRATCH_FILE',
                                                                'DATA_FRAME',
                                                                'DATASET',
                                                                'DROPDOWN_OPTION',
                                                                'BATCH',
                                                                'BIOENTITY',
                                                                'BASIC_FOLDER_ITEM',
                                                                'MIXTURE',
                                                                'MOLECULE',
                                                                'PROTEIN',
                                                                'SEQUENCE',
                                                                'ENTRY',
                                                                'PROTOCOL',
                                                                'REQUEST',
                                                                'RESULT',
                                                                'RUN',
                                                                'STORABLE',
                                                                'BOX',
                                                                'CONTAINER',
                                                                'LOCATION',
                                                                'PLATE',
                                                                'PROCESS',
                                                                'PROCESS_TASK',
                                                                'PROCESS_OUTPUT',
                                                                'STUDY',
                                                                'TEAM',
                                                                'TEST_ORDER',
                                                                'USER'
                                                              ]
                                                            }
                                                          },
                                                          listType: {
                                                            kind: 'enum',
                                                            required: false,
                                                            choices: [
                                                              'ALLOWED',
                                                              'REQUIRED',
                                                              'NOT_ALLOWED'
                                                            ]
                                                          },
                                                          nullableType: {
                                                            kind: 'enum',
                                                            required: false,
                                                            choices: [
                                                              'ALLOWED',
                                                              'REQUIRED',
                                                              'NOT_ALLOWED'
                                                            ]
                                                          }
                                                        }
                                                      },
                                                      required: {
                                                        kind: 'boolean',
                                                        required: true
                                                      }
                                                    }
                                                  },
                                                  {
                                                    kind: 'shape',
                                                    required: true,
                                                    fields: {
                                                      kind: {
                                                        kind: 'string',
                                                        required: true,
                                                        value: 'columnValue'
                                                      },
                                                      columnSystemName: {
                                                        kind: 'string',
                                                        required: true
                                                      },
                                                      inputDataName: {
                                                        kind: 'string',
                                                        required: true
                                                      },
                                                      inputDataIndex: {
                                                        kind: 'integer',
                                                        required: true
                                                      },
                                                      required: {
                                                        kind: 'boolean',
                                                        required: true
                                                      }
                                                    }
                                                  },
                                                  {
                                                    kind: 'shape',
                                                    required: true,
                                                    fields: {
                                                      kind: {
                                                        kind: 'string',
                                                        required: true,
                                                        value: 'date'
                                                      },
                                                      required: {
                                                        kind: 'boolean',
                                                        required: true
                                                      }
                                                    }
                                                  },
                                                  {
                                                    kind: 'shape',
                                                    required: true,
                                                    fields: {
                                                      kind: {
                                                        kind: 'string',
                                                        required: true,
                                                        value: 'enum'
                                                      },
                                                      choices: {
                                                        kind: 'array',
                                                        required: true,
                                                        elementSpec: {
                                                          kind: 'string',
                                                          required: true
                                                        }
                                                      },
                                                      required: {
                                                        kind: 'boolean',
                                                        required: true
                                                      }
                                                    }
                                                  },
                                                  {
                                                    kind: 'shape',
                                                    required: true,
                                                    fields: {
                                                      kind: {
                                                        kind: 'string',
                                                        required: true,
                                                        value: 'integer'
                                                      },
                                                      minValue: {
                                                        kind: 'integer',
                                                        required: false
                                                      },
                                                      maxValue: {
                                                        kind: 'integer',
                                                        required: false
                                                      },
                                                      required: {
                                                        kind: 'boolean',
                                                        required: true
                                                      }
                                                    }
                                                  },
                                                  {
                                                    kind: 'shape',
                                                    required: true,
                                                    fields: {
                                                      kind: {
                                                        kind: 'string',
                                                        required: true,
                                                        value: 'number'
                                                      },
                                                      required: {
                                                        kind: 'boolean',
                                                        required: true
                                                      }
                                                    }
                                                  },
                                                  {
                                                    kind: 'shape',
                                                    required: true,
                                                    fields: {
                                                      kind: {
                                                        kind: 'string',
                                                        required: true,
                                                        value: 'string'
                                                      },
                                                      value: {
                                                        kind: 'string',
                                                        required: false
                                                      },
                                                      pattern: {
                                                        kind: 'string',
                                                        required: false
                                                      },
                                                      required: {
                                                        kind: 'boolean',
                                                        required: true
                                                      }
                                                    }
                                                  },
                                                  {
                                                    kind: 'shape',
                                                    required: true,
                                                    fields: {
                                                      kind: {
                                                        kind: 'string',
                                                        required: true,
                                                        value: 'tableReference'
                                                      },
                                                      inputDataName: {
                                                        kind: 'string',
                                                        required: true
                                                      },
                                                      inputDataIndex: {
                                                        kind: 'integer',
                                                        required: true
                                                      },
                                                      required: {
                                                        kind: 'boolean',
                                                        required: true
                                                      }
                                                    }
                                                  }
                                                ]
                                              }
                                            }
                                          }
                                        },
                                        uiSchema: {
                                          kind: 'shape',
                                          required: true,
                                          fields: {
                                            type: {
                                              kind: 'string',
                                              required: true,
                                              value: 'SHAPE'
                                            },
                                            sectionName: {
                                              kind: 'string',
                                              required: false
                                            },
                                            showDividerLine: {
                                              kind: 'boolean',
                                              required: false
                                            },
                                            conditional: {
                                              kind: 'shape',
                                              required: false,
                                              fields: {
                                                tagValue: {
                                                  kind: 'string',
                                                  required: true
                                                },
                                                configShapePath: {
                                                  kind: 'array',
                                                  required: true,
                                                  elementSpec: {
                                                    kind: 'string',
                                                    required: true
                                                  }
                                                }
                                              }
                                            },
                                            infoText: {
                                              kind: 'string',
                                              required: false
                                            },
                                            isCollapsible: {
                                              kind: 'boolean',
                                              required: false
                                            },
                                            numColumns: {
                                              kind: 'integer',
                                              required: false
                                            },
                                            fields: {
                                              kind: 'array',
                                              required: true,
                                              elementSpec: {
                                                kind: 'shape',
                                                required: true,
                                                fields: {
                                                  key: {
                                                    kind: 'string',
                                                    required: true
                                                  },
                                                  uiSchema: {
                                                    kind: 'taggedUnion',
                                                    required: true,
                                                    tagKey: 'type',
                                                    choices: [
                                                      {
                                                        kind: 'shape',
                                                        required: true,
                                                        fields: {
                                                          type: {
                                                            kind: 'string',
                                                            required: true,
                                                            value: 'FIELD'
                                                          },
                                                          displayName: {
                                                            kind: 'string',
                                                            required: false
                                                          },
                                                          editorOverride: {
                                                            kind: 'enum',
                                                            required: false,
                                                            choices: [
                                                              'CHECKBOX',
                                                              'ICON_SELECTOR',
                                                              'DATE_RANGE'
                                                            ]
                                                          },
                                                          infoText: {
                                                            kind: 'string',
                                                            required: false
                                                          },
                                                          fieldSettings: {
                                                            kind: 'taggedUnion',
                                                            required: false,
                                                            tagKey: 'type',
                                                            choices: [
                                                              {
                                                                kind: 'shape',
                                                                required: true,
                                                                fields: {
                                                                  type: {
                                                                    kind: 'string',
                                                                    required: true,
                                                                    value: 'CHECKBOX_SETTINGS'
                                                                  },
                                                                  checkboxLabel: {
                                                                    kind: 'string',
                                                                    required: true
                                                                  }
                                                                }
                                                              },
                                                              {
                                                                kind: 'shape',
                                                                required: true,
                                                                fields: {
                                                                  type: {
                                                                    kind: 'string',
                                                                    required: true,
                                                                    value: 'COLUMN_REFERENCE_SETTINGS'
                                                                  },
                                                                  noColumnSelectedText: {
                                                                    kind: 'string',
                                                                    required: false
                                                                  },
                                                                  allowSelectNull: {
                                                                    kind: 'boolean',
                                                                    required: false
                                                                  },
                                                                  systemNameWildcardSelector: {
                                                                    kind: 'string',
                                                                    required: false
                                                                  },
                                                                  renderCyclingSelector: {
                                                                    kind: 'boolean',
                                                                    required: false
                                                                  }
                                                                }
                                                              },
                                                              {
                                                                kind: 'shape',
                                                                required: true,
                                                                fields: {
                                                                  type: {
                                                                    kind: 'string',
                                                                    required: true,
                                                                    value: 'COLUMN_VALUE_SETTINGS'
                                                                  },
                                                                  noValueSelectedText: {
                                                                    kind: 'string',
                                                                    required: false
                                                                  },
                                                                  renderCyclingSelector: {
                                                                    kind: 'boolean',
                                                                    required: false
                                                                  }
                                                                }
                                                              },
                                                              {
                                                                kind: 'shape',
                                                                required: true,
                                                                fields: {
                                                                  type: {
                                                                    kind: 'string',
                                                                    required: true,
                                                                    value: 'RANGE_SETTINGS'
                                                                  },
                                                                  startKey: {
                                                                    kind: 'string',
                                                                    required: true
                                                                  },
                                                                  endKey: {
                                                                    kind: 'string',
                                                                    required: true
                                                                  }
                                                                }
                                                              },
                                                              {
                                                                kind: 'shape',
                                                                required: true,
                                                                fields: {
                                                                  type: {
                                                                    kind: 'string',
                                                                    required: true,
                                                                    value: 'ENUM_SETTINGS'
                                                                  },
                                                                  displayNames: {
                                                                    kind: 'array',
                                                                    required: false,
                                                                    elementSpec: {
                                                                      kind: 'shape',
                                                                      required: true,
                                                                      fields: {
                                                                        value: {
                                                                          kind: 'string',
                                                                          required: true
                                                                        },
                                                                        displayName: {
                                                                          kind: 'string',
                                                                          required: true
                                                                        }
                                                                      }
                                                                    }
                                                                  },
                                                                  renderCyclingSelector: {
                                                                    kind: 'boolean',
                                                                    required: false
                                                                  }
                                                                }
                                                              },
                                                              {
                                                                kind: 'shape',
                                                                required: true,
                                                                fields: {
                                                                  type: {
                                                                    kind: 'string',
                                                                    required: true,
                                                                    value: 'ICON_SELECTOR_SETTINGS'
                                                                  },
                                                                  iconNames: {
                                                                    kind: 'array',
                                                                    required: false,
                                                                    elementSpec: {
                                                                      kind: 'shape',
                                                                      required: true,
                                                                      fields: {
                                                                        value: {
                                                                          kind: 'string',
                                                                          required: true
                                                                        },
                                                                        iconName: {
                                                                          kind: 'string',
                                                                          required: true
                                                                        }
                                                                      }
                                                                    }
                                                                  },
                                                                  displayNames: {
                                                                    kind: 'array',
                                                                    required: false,
                                                                    elementSpec: {
                                                                      kind: 'shape',
                                                                      required: true,
                                                                      fields: {
                                                                        value: {
                                                                          kind: 'string',
                                                                          required: true
                                                                        },
                                                                        displayName: {
                                                                          kind: 'string',
                                                                          required: true
                                                                        }
                                                                      }
                                                                    }
                                                                  },
                                                                  defaultValue: {
                                                                    kind: 'string',
                                                                    required: false
                                                                  }
                                                                }
                                                              },
                                                              {
                                                                kind: 'shape',
                                                                required: true,
                                                                fields: {
                                                                  type: {
                                                                    kind: 'string',
                                                                    required: true,
                                                                    value: 'TABLE_REFERENCE_SETTINGS'
                                                                  },
                                                                  disabledColumn: {
                                                                    kind: 'array',
                                                                    required: false,
                                                                    elementSpec: {
                                                                      kind: 'string',
                                                                      required: true
                                                                    }
                                                                  },
                                                                  hiddenColumn: {
                                                                    kind: 'array',
                                                                    required: false,
                                                                    elementSpec: {
                                                                      kind: 'string',
                                                                      required: true
                                                                    }
                                                                  }
                                                                }
                                                              },
                                                              {
                                                                kind: 'shape',
                                                                required: true,
                                                                fields: {
                                                                  type: {
                                                                    kind: 'string',
                                                                    required: true,
                                                                    value: 'TAGGED_UNION_SETTINGS'
                                                                  },
                                                                  tagKeyDisplayNames: {
                                                                    kind: 'array',
                                                                    required: false,
                                                                    elementSpec: {
                                                                      kind: 'shape',
                                                                      required: true,
                                                                      fields: {
                                                                        value: {
                                                                          kind: 'string',
                                                                          required: true
                                                                        },
                                                                        displayName: {
                                                                          kind: 'string',
                                                                          required: true
                                                                        }
                                                                      }
                                                                    }
                                                                  },
                                                                  renderCyclingSelector: {
                                                                    kind: 'boolean',
                                                                    required: false
                                                                  }
                                                                }
                                                              },
                                                              {
                                                                kind: 'shape',
                                                                required: true,
                                                                fields: {
                                                                  type: {
                                                                    kind: 'string',
                                                                    required: true,
                                                                    value: 'STRING_FIELD_SETTINGS'
                                                                  },
                                                                  useTextArea: {
                                                                    kind: 'boolean',
                                                                    required: false
                                                                  }
                                                                }
                                                              }
                                                            ]
                                                          }
                                                        }
                                                      },
                                                      {
                                                        kind: 'shape',
                                                        required: true,
                                                        fields: {
                                                          type: {
                                                            kind: 'string',
                                                            required: true,
                                                            value: 'ACTION_BUTTON'
                                                          },
                                                          action: {
                                                            kind: 'enum',
                                                            required: true,
                                                            choices: [
                                                              'RESET',
                                                              'SUBMIT'
                                                            ]
                                                          },
                                                          buttonText: {
                                                            kind: 'string',
                                                            required: true
                                                          },
                                                          buttonIcon: {
                                                            kind: 'string',
                                                            required: false
                                                          },
                                                          buttonVariant: {
                                                            kind: 'enum',
                                                            required: false,
                                                            choices: [
                                                              'primary',
                                                              'secondary'
                                                            ]
                                                          },
                                                          helpText: {
                                                            kind: 'string',
                                                            required: false
                                                          }
                                                        }
                                                      },
                                                      {
                                                        kind: 'shape',
                                                        required: true,
                                                        fields: {
                                                          type: {
                                                            kind: 'string',
                                                            required: true,
                                                            value: 'MARKDOWN'
                                                          },
                                                          markdown: {
                                                            kind: 'string',
                                                            required: true
                                                          }
                                                        }
                                                      },
                                                      {
                                                        kind: 'shape',
                                                        required: true,
                                                        fields: {
                                                          type: {
                                                            kind: 'string',
                                                            required: true,
                                                            value: 'SHAPE'
                                                          },
                                                          sectionName: {
                                                            kind: 'string',
                                                            required: false
                                                          },
                                                          showDividerLine: {
                                                            kind: 'boolean',
                                                            required: false
                                                          },
                                                          conditional: {
                                                            kind: 'shape',
                                                            required: false,
                                                            fields: {
                                                              tagValue: {
                                                                kind: 'string',
                                                                required: true
                                                              },
                                                              configShapePath: {
                                                                kind: 'array',
                                                                required: true,
                                                                elementSpec: {
                                                                  kind: 'string',
                                                                  required: true
                                                                }
                                                              }
                                                            }
                                                          },
                                                          infoText: {
                                                            kind: 'string',
                                                            required: false
                                                          },
                                                          isCollapsible: {
                                                            kind: 'boolean',
                                                            required: false
                                                          },
                                                          numColumns: {
                                                            kind: 'integer',
                                                            required: false
                                                          },
                                                          fields: {
                                                            kind: 'array',
                                                            required: true,
                                                            elementSpec: {
                                                              kind: 'shape',
                                                              required: true,
                                                              fields: {
                                                                key: {
                                                                  kind: 'string',
                                                                  required: true
                                                                },
                                                                uiSchema: {
                                                                  kind: 'taggedUnion',
                                                                  required: true,
                                                                  tagKey: 'type',
                                                                  choices: [
                                                                    {
                                                                      kind: 'shape',
                                                                      required: true,
                                                                      fields: {
                                                                        type: {
                                                                          kind: 'string',
                                                                          required: true,
                                                                          value: 'FIELD'
                                                                        },
                                                                        displayName: {
                                                                          kind: 'string',
                                                                          required: false
                                                                        },
                                                                        editorOverride: {
                                                                          kind: 'enum',
                                                                          required: false,
                                                                          choices: [
                                                                            'CHECKBOX',
                                                                            'ICON_SELECTOR',
                                                                            'DATE_RANGE'
                                                                          ]
                                                                        },
                                                                        infoText: {
                                                                          kind: 'string',
                                                                          required: false
                                                                        },
                                                                        fieldSettings: {
                                                                          kind: 'taggedUnion',
                                                                          required: false,
                                                                          tagKey: 'type',
                                                                          choices: [
                                                                            {
                                                                              kind: 'shape',
                                                                              required: true,
                                                                              fields: {
                                                                                type: {
                                                                                  kind: 'string',
                                                                                  required: true,
                                                                                  value: 'CHECKBOX_SETTINGS'
                                                                                },
                                                                                checkboxLabel: {
                                                                                  kind: 'string',
                                                                                  required: true
                                                                                }
                                                                              }
                                                                            },
                                                                            {
                                                                              kind: 'shape',
                                                                              required: true,
                                                                              fields: {
                                                                                type: {
                                                                                  kind: 'string',
                                                                                  required: true,
                                                                                  value: 'COLUMN_REFERENCE_SETTINGS'
                                                                                },
                                                                                noColumnSelectedText: {
                                                                                  kind: 'string',
                                                                                  required: false
                                                                                },
                                                                                allowSelectNull: {
                                                                                  kind: 'boolean',
                                                                                  required: false
                                                                                },
                                                                                systemNameWildcardSelector: {
                                                                                  kind: 'string',
                                                                                  required: false
                                                                                },
                                                                                renderCyclingSelector: {
                                                                                  kind: 'boolean',
                                                                                  required: false
                                                                                }
                                                                              }
                                                                            },
                                                                            {
                                                                              kind: 'shape',
                                                                              required: true,
                                                                              fields: {
                                                                                type: {
                                                                                  kind: 'string',
                                                                                  required: true,
                                                                                  value: 'COLUMN_VALUE_SETTINGS'
                                                                                },
                                                                                noValueSelectedText: {
                                                                                  kind: 'string',
                                                                                  required: false
                                                                                },
                                                                                renderCyclingSelector: {
                                                                                  kind: 'boolean',
                                                                                  required: false
                                                                                }
                                                                              }
                                                                            },
                                                                            {
                                                                              kind: 'shape',
                                                                              required: true,
                                                                              fields: {
                                                                                type: {
                                                                                  kind: 'string',
                                                                                  required: true,
                                                                                  value: 'RANGE_SETTINGS'
                                                                                },
                                                                                startKey: {
                                                                                  kind: 'string',
                                                                                  required: true
                                                                                },
                                                                                endKey: {
                                                                                  kind: 'string',
                                                                                  required: true
                                                                                }
                                                                              }
                                                                            },
                                                                            {
                                                                              kind: 'shape',
                                                                              required: true,
                                                                              fields: {
                                                                                type: {
                                                                                  kind: 'string',
                                                                                  required: true,
                                                                                  value: 'ENUM_SETTINGS'
                                                                                },
                                                                                displayNames: {
                                                                                  kind: 'array',
                                                                                  required: false,
                                                                                  elementSpec: {
                                                                                    kind: 'shape',
                                                                                    required: true,
                                                                                    fields: {
                                                                                      value: {
                                                                                        kind: 'string',
                                                                                        required: true
                                                                                      },
                                                                                      displayName: {
                                                                                        kind: 'string',
                                                                                        required: true
                                                                                      }
                                                                                    }
                                                                                  }
                                                                                },
                                                                                renderCyclingSelector: {
                                                                                  kind: 'boolean',
                                                                                  required: false
                                                                                }
                                                                              }
                                                                            },
                                                                            {
                                                                              kind: 'shape',
                                                                              required: true,
                                                                              fields: {
                                                                                type: {
                                                                                  kind: 'string',
                                                                                  required: true,
                                                                                  value: 'ICON_SELECTOR_SETTINGS'
                                                                                },
                                                                                iconNames: {
                                                                                  kind: 'array',
                                                                                  required: false,
                                                                                  elementSpec: {
                                                                                    kind: 'shape',
                                                                                    required: true,
                                                                                    fields: {
                                                                                      value: {
                                                                                        kind: 'string',
                                                                                        required: true
                                                                                      },
                                                                                      iconName: {
                                                                                        kind: 'string',
                                                                                        required: true
                                                                                      }
                                                                                    }
                                                                                  }
                                                                                },
                                                                                displayNames: {
                                                                                  kind: 'array',
                                                                                  required: false,
                                                                                  elementSpec: {
                                                                                    kind: 'shape',
                                                                                    required: true,
                                                                                    fields: {
                                                                                      value: {
                                                                                        kind: 'string',
                                                                                        required: true
                                                                                      },
                                                                                      displayName: {
                                                                                        kind: 'string',
                                                                                        required: true
                                                                                      }
                                                                                    }
                                                                                  }
                                                                                },
                                                                                defaultValue: {
                                                                                  kind: 'string',
                                                                                  required: false
                                                                                }
                                                                              }
                                                                            },
                                                                            {
                                                                              kind: 'shape',
                                                                              required: true,
                                                                              fields: {
                                                                                type: {
                                                                                  kind: 'string',
                                                                                  required: true,
                                                                                  value: 'TABLE_REFERENCE_SETTINGS'
                                                                                },
                                                                                disabledColumn: {
                                                                                  kind: 'array',
                                                                                  required: false,
                                                                                  elementSpec: {
                                                                                    kind: 'string',
                                                                                    required: true
                                                                                  }
                                                                                },
                                                                                hiddenColumn: {
                                                                                  kind: 'array',
                                                                                  required: false,
                                                                                  elementSpec: {
                                                                                    kind: 'string',
                                                                                    required: true
                                                                                  }
                                                                                }
                                                                              }
                                                                            },
                                                                            {
                                                                              kind: 'shape',
                                                                              required: true,
                                                                              fields: {
                                                                                type: {
                                                                                  kind: 'string',
                                                                                  required: true,
                                                                                  value: 'TAGGED_UNION_SETTINGS'
                                                                                },
                                                                                tagKeyDisplayNames: {
                                                                                  kind: 'array',
                                                                                  required: false,
                                                                                  elementSpec: {
                                                                                    kind: 'shape',
                                                                                    required: true,
                                                                                    fields: {
                                                                                      value: {
                                                                                        kind: 'string',
                                                                                        required: true
                                                                                      },
                                                                                      displayName: {
                                                                                        kind: 'string',
                                                                                        required: true
                                                                                      }
                                                                                    }
                                                                                  }
                                                                                },
                                                                                renderCyclingSelector: {
                                                                                  kind: 'boolean',
                                                                                  required: false
                                                                                }
                                                                              }
                                                                            },
                                                                            {
                                                                              kind: 'shape',
                                                                              required: true,
                                                                              fields: {
                                                                                type: {
                                                                                  kind: 'string',
                                                                                  required: true,
                                                                                  value: 'STRING_FIELD_SETTINGS'
                                                                                },
                                                                                useTextArea: {
                                                                                  kind: 'boolean',
                                                                                  required: false
                                                                                }
                                                                              }
                                                                            }
                                                                          ]
                                                                        }
                                                                      }
                                                                    },
                                                                    {
                                                                      kind: 'shape',
                                                                      required: true,
                                                                      fields: {
                                                                        type: {
                                                                          kind: 'string',
                                                                          required: true,
                                                                          value: 'ACTION_BUTTON'
                                                                        },
                                                                        action: {
                                                                          kind: 'enum',
                                                                          required: true,
                                                                          choices: [
                                                                            'RESET',
                                                                            'SUBMIT'
                                                                          ]
                                                                        },
                                                                        buttonText: {
                                                                          kind: 'string',
                                                                          required: true
                                                                        },
                                                                        buttonIcon: {
                                                                          kind: 'string',
                                                                          required: false
                                                                        },
                                                                        buttonVariant: {
                                                                          kind: 'enum',
                                                                          required: false,
                                                                          choices: [
                                                                            'primary',
                                                                            'secondary'
                                                                          ]
                                                                        },
                                                                        helpText: {
                                                                          kind: 'string',
                                                                          required: false
                                                                        }
                                                                      }
                                                                    },
                                                                    {
                                                                      kind: 'shape',
                                                                      required: true,
                                                                      fields: {
                                                                        type: {
                                                                          kind: 'string',
                                                                          required: true,
                                                                          value: 'MARKDOWN'
                                                                        },
                                                                        markdown: {
                                                                          kind: 'string',
                                                                          required: true
                                                                        }
                                                                      }
                                                                    }
                                                                  ]
                                                                }
                                                              }
                                                            },
                                                            minItems: 1
                                                          }
                                                        }
                                                      }
                                                    ]
                                                  }
                                                }
                                              },
                                              minItems: 1
                                            }
                                          }
                                        }
                                      }
                                    },
                                    {
                                      kind: 'shape',
                                      required: true,
                                      fields: {
                                        type: {
                                          kind: 'string',
                                          required: true,
                                          value: 'MARKDOWN'
                                        },
                                        markdown: {
                                          kind: 'string',
                                          required: true
                                        },
                                        blockConfig: {
                                          kind: 'taggedUnion',
                                          required: false,
                                          tagKey: 'blockMode',
                                          choices: [
                                            {
                                              kind: 'shape',
                                              required: true,
                                              fields: {
                                                blockMode: {
                                                  kind: 'string',
                                                  required: true,
                                                  value: 'PANE'
                                                },
                                                title: {
                                                  kind: 'string',
                                                  required: false
                                                },
                                                subtitle: {
                                                  kind: 'string',
                                                  required: false
                                                },
                                                infoText: {
                                                  kind: 'string',
                                                  required: false
                                                },
                                                isCollapsible: {
                                                  kind: 'boolean',
                                                  required: false
                                                }
                                              }
                                            },
                                            {
                                              kind: 'shape',
                                              required: true,
                                              fields: {
                                                blockMode: {
                                                  kind: 'string',
                                                  required: true,
                                                  value: 'CONTENT_ONLY'
                                                },
                                                isCollapsible: {
                                                  kind: 'boolean',
                                                  required: false
                                                }
                                              }
                                            }
                                          ]
                                        }
                                      }
                                    },
                                    {
                                      kind: 'shape',
                                      required: true,
                                      fields: {
                                        type: {
                                          kind: 'string',
                                          required: true,
                                          value: 'PLACEHOLDER'
                                        }
                                      }
                                    }
                                  ]
                                }
                              }
                            }
                          }
                        },
                        {
                          kind: 'shape',
                          required: true,
                          fields: {
                            type: {
                              kind: 'string',
                              required: true,
                              value: 'PLACEHOLDER'
                            }
                          }
                        }
                      ]
                    }
                  }
                }
              }
            },
            {
              kind: 'shape',
              required: true,
              fields: {
                type: {
                  kind: 'string',
                  required: true,
                  value: 'TAB'
                },
                title: {
                  kind: 'string',
                  required: false
                },
                tabs: {
                  kind: 'array',
                  required: true,
                  elementSpec: {
                    kind: 'shape',
                    required: true,
                    fields: {
                      title: {
                        kind: 'string',
                        required: true
                      },
                      gridMode: {
                        kind: 'enum',
                        required: false,
                        choices: [
                          'SEPARATED',
                          'COMBINED'
                        ]
                      },
                      rows: {
                        kind: 'array',
                        required: true,
                        elementSpec: {
                          kind: 'array',
                          required: true,
                          elementSpec: {
                            kind: 'taggedUnion',
                            required: true,
                            tagKey: 'type',
                            choices: [
                              {
                                kind: 'shape',
                                required: true,
                                fields: {
                                  type: {
                                    kind: 'string',
                                    required: true,
                                    value: 'DATA'
                                  },
                                  inputReference: {
                                    kind: 'shape',
                                    required: true,
                                    fields: {
                                      inputDataName: {
                                        kind: 'enum',
                                        required: true,
                                        choices: [
                                          'Input datasets',
                                          'Input charts',
                                          'Input files'
                                        ]
                                      },
                                      inputDataIndex: {
                                        kind: 'integer',
                                        required: true
                                      }
                                    }
                                  },
                                  blockConfig: {
                                    kind: 'taggedUnion',
                                    required: false,
                                    tagKey: 'blockMode',
                                    choices: [
                                      {
                                        kind: 'shape',
                                        required: true,
                                        fields: {
                                          blockMode: {
                                            kind: 'string',
                                            required: true,
                                            value: 'PANE'
                                          },
                                          title: {
                                            kind: 'string',
                                            required: false
                                          },
                                          subtitle: {
                                            kind: 'string',
                                            required: false
                                          },
                                          infoText: {
                                            kind: 'string',
                                            required: false
                                          },
                                          isCollapsible: {
                                            kind: 'boolean',
                                            required: false
                                          }
                                        }
                                      },
                                      {
                                        kind: 'shape',
                                        required: true,
                                        fields: {
                                          blockMode: {
                                            kind: 'string',
                                            required: true,
                                            value: 'CONTENT_ONLY'
                                          },
                                          isCollapsible: {
                                            kind: 'boolean',
                                            required: false
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  tableConfig: {
                                    kind: 'shape',
                                    required: false,
                                    fields: {
                                      tableMode: {
                                        kind: 'enum',
                                        required: false,
                                        choices: [
                                          'TEXT',
                                          'RICH'
                                        ]
                                      }
                                    }
                                  }
                                }
                              },
                              {
                                kind: 'shape',
                                required: true,
                                fields: {
                                  type: {
                                    kind: 'string',
                                    required: true,
                                    value: 'CONFIG_FORM'
                                  },
                                  blockConfig: {
                                    kind: 'taggedUnion',
                                    required: false,
                                    tagKey: 'blockMode',
                                    choices: [
                                      {
                                        kind: 'shape',
                                        required: true,
                                        fields: {
                                          blockMode: {
                                            kind: 'string',
                                            required: true,
                                            value: 'PANE'
                                          },
                                          title: {
                                            kind: 'string',
                                            required: false
                                          },
                                          subtitle: {
                                            kind: 'string',
                                            required: false
                                          },
                                          infoText: {
                                            kind: 'string',
                                            required: false
                                          },
                                          isCollapsible: {
                                            kind: 'boolean',
                                            required: false
                                          }
                                        }
                                      },
                                      {
                                        kind: 'shape',
                                        required: true,
                                        fields: {
                                          blockMode: {
                                            kind: 'string',
                                            required: true,
                                            value: 'CONTENT_ONLY'
                                          },
                                          isCollapsible: {
                                            kind: 'boolean',
                                            required: false
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  configFields: {
                                    kind: 'array',
                                    required: true,
                                    elementSpec: {
                                      kind: 'shape',
                                      required: true,
                                      fields: {
                                        key: {
                                          kind: 'string',
                                          required: true
                                        },
                                        configReferences: {
                                          kind: 'array',
                                          required: true,
                                          elementSpec: {
                                            kind: 'shape',
                                            required: true,
                                            fields: {
                                              inputDataName: {
                                                kind: 'enum',
                                                required: true,
                                                choices: [
                                                  'Input datasets',
                                                  'Input charts',
                                                  'Input files'
                                                ]
                                              },
                                              inputDataIndex: {
                                                kind: 'integer',
                                                required: true
                                              },
                                              configPath: {
                                                kind: 'array',
                                                required: true,
                                                elementSpec: {
                                                  kind: 'anything',
                                                  required: true
                                                }
                                              }
                                            }
                                          },
                                          minItems: 1
                                        },
                                        configSpec: {
                                          kind: 'taggedUnion',
                                          required: true,
                                          tagKey: 'kind',
                                          choices: [
                                            {
                                              kind: 'shape',
                                              required: true,
                                              fields: {
                                                kind: {
                                                  kind: 'string',
                                                  required: true,
                                                  value: 'boolean'
                                                },
                                                required: {
                                                  kind: 'boolean',
                                                  required: true
                                                }
                                              }
                                            },
                                            {
                                              kind: 'shape',
                                              required: true,
                                              fields: {
                                                kind: {
                                                  kind: 'string',
                                                  required: true,
                                                  value: 'columnReference'
                                                },
                                                inputDataName: {
                                                  kind: 'string',
                                                  required: true
                                                },
                                                validationOptions: {
                                                  kind: 'shape',
                                                  required: false,
                                                  fields: {
                                                    allowedLeafTypes: {
                                                      kind: 'array',
                                                      required: false,
                                                      elementSpec: {
                                                        kind: 'enum',
                                                        required: true,
                                                        choices: [
                                                          'BOOLEAN',
                                                          'DATETIME',
                                                          'DATE',
                                                          'DECIMAL',
                                                          'INTEGER',
                                                          'JSON',
                                                          'TEXT',
                                                          'BENCHLING_OBJECT',
                                                          'BLOB',
                                                          'CHART',
                                                          'FILE',
                                                          'SCRATCH_FILE',
                                                          'DATA_FRAME',
                                                          'DATASET',
                                                          'DROPDOWN_OPTION',
                                                          'BATCH',
                                                          'BIOENTITY',
                                                          'BASIC_FOLDER_ITEM',
                                                          'MIXTURE',
                                                          'MOLECULE',
                                                          'PROTEIN',
                                                          'SEQUENCE',
                                                          'ENTRY',
                                                          'PROTOCOL',
                                                          'REQUEST',
                                                          'RESULT',
                                                          'RUN',
                                                          'STORABLE',
                                                          'BOX',
                                                          'CONTAINER',
                                                          'LOCATION',
                                                          'PLATE',
                                                          'PROCESS',
                                                          'PROCESS_TASK',
                                                          'PROCESS_OUTPUT',
                                                          'STUDY',
                                                          'TEAM',
                                                          'TEST_ORDER',
                                                          'USER'
                                                        ]
                                                      }
                                                    },
                                                    listType: {
                                                      kind: 'enum',
                                                      required: false,
                                                      choices: [
                                                        'ALLOWED',
                                                        'REQUIRED',
                                                        'NOT_ALLOWED'
                                                      ]
                                                    },
                                                    nullableType: {
                                                      kind: 'enum',
                                                      required: false,
                                                      choices: [
                                                        'ALLOWED',
                                                        'REQUIRED',
                                                        'NOT_ALLOWED'
                                                      ]
                                                    }
                                                  }
                                                },
                                                required: {
                                                  kind: 'boolean',
                                                  required: true
                                                }
                                              }
                                            },
                                            {
                                              kind: 'shape',
                                              required: true,
                                              fields: {
                                                kind: {
                                                  kind: 'string',
                                                  required: true,
                                                  value: 'columnValue'
                                                },
                                                columnSystemName: {
                                                  kind: 'string',
                                                  required: true
                                                },
                                                inputDataName: {
                                                  kind: 'string',
                                                  required: true
                                                },
                                                inputDataIndex: {
                                                  kind: 'integer',
                                                  required: true
                                                },
                                                required: {
                                                  kind: 'boolean',
                                                  required: true
                                                }
                                              }
                                            },
                                            {
                                              kind: 'shape',
                                              required: true,
                                              fields: {
                                                kind: {
                                                  kind: 'string',
                                                  required: true,
                                                  value: 'date'
                                                },
                                                required: {
                                                  kind: 'boolean',
                                                  required: true
                                                }
                                              }
                                            },
                                            {
                                              kind: 'shape',
                                              required: true,
                                              fields: {
                                                kind: {
                                                  kind: 'string',
                                                  required: true,
                                                  value: 'enum'
                                                },
                                                choices: {
                                                  kind: 'array',
                                                  required: true,
                                                  elementSpec: {
                                                    kind: 'string',
                                                    required: true
                                                  }
                                                },
                                                required: {
                                                  kind: 'boolean',
                                                  required: true
                                                }
                                              }
                                            },
                                            {
                                              kind: 'shape',
                                              required: true,
                                              fields: {
                                                kind: {
                                                  kind: 'string',
                                                  required: true,
                                                  value: 'integer'
                                                },
                                                minValue: {
                                                  kind: 'integer',
                                                  required: false
                                                },
                                                maxValue: {
                                                  kind: 'integer',
                                                  required: false
                                                },
                                                required: {
                                                  kind: 'boolean',
                                                  required: true
                                                }
                                              }
                                            },
                                            {
                                              kind: 'shape',
                                              required: true,
                                              fields: {
                                                kind: {
                                                  kind: 'string',
                                                  required: true,
                                                  value: 'number'
                                                },
                                                required: {
                                                  kind: 'boolean',
                                                  required: true
                                                }
                                              }
                                            },
                                            {
                                              kind: 'shape',
                                              required: true,
                                              fields: {
                                                kind: {
                                                  kind: 'string',
                                                  required: true,
                                                  value: 'string'
                                                },
                                                value: {
                                                  kind: 'string',
                                                  required: false
                                                },
                                                pattern: {
                                                  kind: 'string',
                                                  required: false
                                                },
                                                required: {
                                                  kind: 'boolean',
                                                  required: true
                                                }
                                              }
                                            },
                                            {
                                              kind: 'shape',
                                              required: true,
                                              fields: {
                                                kind: {
                                                  kind: 'string',
                                                  required: true,
                                                  value: 'tableReference'
                                                },
                                                inputDataName: {
                                                  kind: 'string',
                                                  required: true
                                                },
                                                inputDataIndex: {
                                                  kind: 'integer',
                                                  required: true
                                                },
                                                required: {
                                                  kind: 'boolean',
                                                  required: true
                                                }
                                              }
                                            }
                                          ]
                                        }
                                      }
                                    }
                                  },
                                  uiSchema: {
                                    kind: 'shape',
                                    required: true,
                                    fields: {
                                      type: {
                                        kind: 'string',
                                        required: true,
                                        value: 'SHAPE'
                                      },
                                      sectionName: {
                                        kind: 'string',
                                        required: false
                                      },
                                      showDividerLine: {
                                        kind: 'boolean',
                                        required: false
                                      },
                                      conditional: {
                                        kind: 'shape',
                                        required: false,
                                        fields: {
                                          tagValue: {
                                            kind: 'string',
                                            required: true
                                          },
                                          configShapePath: {
                                            kind: 'array',
                                            required: true,
                                            elementSpec: {
                                              kind: 'string',
                                              required: true
                                            }
                                          }
                                        }
                                      },
                                      infoText: {
                                        kind: 'string',
                                        required: false
                                      },
                                      isCollapsible: {
                                        kind: 'boolean',
                                        required: false
                                      },
                                      numColumns: {
                                        kind: 'integer',
                                        required: false
                                      },
                                      fields: {
                                        kind: 'array',
                                        required: true,
                                        elementSpec: {
                                          kind: 'shape',
                                          required: true,
                                          fields: {
                                            key: {
                                              kind: 'string',
                                              required: true
                                            },
                                            uiSchema: {
                                              kind: 'taggedUnion',
                                              required: true,
                                              tagKey: 'type',
                                              choices: [
                                                {
                                                  kind: 'shape',
                                                  required: true,
                                                  fields: {
                                                    type: {
                                                      kind: 'string',
                                                      required: true,
                                                      value: 'FIELD'
                                                    },
                                                    displayName: {
                                                      kind: 'string',
                                                      required: false
                                                    },
                                                    editorOverride: {
                                                      kind: 'enum',
                                                      required: false,
                                                      choices: [
                                                        'CHECKBOX',
                                                        'ICON_SELECTOR',
                                                        'DATE_RANGE'
                                                      ]
                                                    },
                                                    infoText: {
                                                      kind: 'string',
                                                      required: false
                                                    },
                                                    fieldSettings: {
                                                      kind: 'taggedUnion',
                                                      required: false,
                                                      tagKey: 'type',
                                                      choices: [
                                                        {
                                                          kind: 'shape',
                                                          required: true,
                                                          fields: {
                                                            type: {
                                                              kind: 'string',
                                                              required: true,
                                                              value: 'CHECKBOX_SETTINGS'
                                                            },
                                                            checkboxLabel: {
                                                              kind: 'string',
                                                              required: true
                                                            }
                                                          }
                                                        },
                                                        {
                                                          kind: 'shape',
                                                          required: true,
                                                          fields: {
                                                            type: {
                                                              kind: 'string',
                                                              required: true,
                                                              value: 'COLUMN_REFERENCE_SETTINGS'
                                                            },
                                                            noColumnSelectedText: {
                                                              kind: 'string',
                                                              required: false
                                                            },
                                                            allowSelectNull: {
                                                              kind: 'boolean',
                                                              required: false
                                                            },
                                                            systemNameWildcardSelector: {
                                                              kind: 'string',
                                                              required: false
                                                            },
                                                            renderCyclingSelector: {
                                                              kind: 'boolean',
                                                              required: false
                                                            }
                                                          }
                                                        },
                                                        {
                                                          kind: 'shape',
                                                          required: true,
                                                          fields: {
                                                            type: {
                                                              kind: 'string',
                                                              required: true,
                                                              value: 'COLUMN_VALUE_SETTINGS'
                                                            },
                                                            noValueSelectedText: {
                                                              kind: 'string',
                                                              required: false
                                                            },
                                                            renderCyclingSelector: {
                                                              kind: 'boolean',
                                                              required: false
                                                            }
                                                          }
                                                        },
                                                        {
                                                          kind: 'shape',
                                                          required: true,
                                                          fields: {
                                                            type: {
                                                              kind: 'string',
                                                              required: true,
                                                              value: 'RANGE_SETTINGS'
                                                            },
                                                            startKey: {
                                                              kind: 'string',
                                                              required: true
                                                            },
                                                            endKey: {
                                                              kind: 'string',
                                                              required: true
                                                            }
                                                          }
                                                        },
                                                        {
                                                          kind: 'shape',
                                                          required: true,
                                                          fields: {
                                                            type: {
                                                              kind: 'string',
                                                              required: true,
                                                              value: 'ENUM_SETTINGS'
                                                            },
                                                            displayNames: {
                                                              kind: 'array',
                                                              required: false,
                                                              elementSpec: {
                                                                kind: 'shape',
                                                                required: true,
                                                                fields: {
                                                                  value: {
                                                                    kind: 'string',
                                                                    required: true
                                                                  },
                                                                  displayName: {
                                                                    kind: 'string',
                                                                    required: true
                                                                  }
                                                                }
                                                              }
                                                            },
                                                            renderCyclingSelector: {
                                                              kind: 'boolean',
                                                              required: false
                                                            }
                                                          }
                                                        },
                                                        {
                                                          kind: 'shape',
                                                          required: true,
                                                          fields: {
                                                            type: {
                                                              kind: 'string',
                                                              required: true,
                                                              value: 'ICON_SELECTOR_SETTINGS'
                                                            },
                                                            iconNames: {
                                                              kind: 'array',
                                                              required: false,
                                                              elementSpec: {
                                                                kind: 'shape',
                                                                required: true,
                                                                fields: {
                                                                  value: {
                                                                    kind: 'string',
                                                                    required: true
                                                                  },
                                                                  iconName: {
                                                                    kind: 'string',
                                                                    required: true
                                                                  }
                                                                }
                                                              }
                                                            },
                                                            displayNames: {
                                                              kind: 'array',
                                                              required: false,
                                                              elementSpec: {
                                                                kind: 'shape',
                                                                required: true,
                                                                fields: {
                                                                  value: {
                                                                    kind: 'string',
                                                                    required: true
                                                                  },
                                                                  displayName: {
                                                                    kind: 'string',
                                                                    required: true
                                                                  }
                                                                }
                                                              }
                                                            },
                                                            defaultValue: {
                                                              kind: 'string',
                                                              required: false
                                                            }
                                                          }
                                                        },
                                                        {
                                                          kind: 'shape',
                                                          required: true,
                                                          fields: {
                                                            type: {
                                                              kind: 'string',
                                                              required: true,
                                                              value: 'TABLE_REFERENCE_SETTINGS'
                                                            },
                                                            disabledColumn: {
                                                              kind: 'array',
                                                              required: false,
                                                              elementSpec: {
                                                                kind: 'string',
                                                                required: true
                                                              }
                                                            },
                                                            hiddenColumn: {
                                                              kind: 'array',
                                                              required: false,
                                                              elementSpec: {
                                                                kind: 'string',
                                                                required: true
                                                              }
                                                            }
                                                          }
                                                        },
                                                        {
                                                          kind: 'shape',
                                                          required: true,
                                                          fields: {
                                                            type: {
                                                              kind: 'string',
                                                              required: true,
                                                              value: 'TAGGED_UNION_SETTINGS'
                                                            },
                                                            tagKeyDisplayNames: {
                                                              kind: 'array',
                                                              required: false,
                                                              elementSpec: {
                                                                kind: 'shape',
                                                                required: true,
                                                                fields: {
                                                                  value: {
                                                                    kind: 'string',
                                                                    required: true
                                                                  },
                                                                  displayName: {
                                                                    kind: 'string',
                                                                    required: true
                                                                  }
                                                                }
                                                              }
                                                            },
                                                            renderCyclingSelector: {
                                                              kind: 'boolean',
                                                              required: false
                                                            }
                                                          }
                                                        },
                                                        {
                                                          kind: 'shape',
                                                          required: true,
                                                          fields: {
                                                            type: {
                                                              kind: 'string',
                                                              required: true,
                                                              value: 'STRING_FIELD_SETTINGS'
                                                            },
                                                            useTextArea: {
                                                              kind: 'boolean',
                                                              required: false
                                                            }
                                                          }
                                                        }
                                                      ]
                                                    }
                                                  }
                                                },
                                                {
                                                  kind: 'shape',
                                                  required: true,
                                                  fields: {
                                                    type: {
                                                      kind: 'string',
                                                      required: true,
                                                      value: 'ACTION_BUTTON'
                                                    },
                                                    action: {
                                                      kind: 'enum',
                                                      required: true,
                                                      choices: [
                                                        'RESET',
                                                        'SUBMIT'
                                                      ]
                                                    },
                                                    buttonText: {
                                                      kind: 'string',
                                                      required: true
                                                    },
                                                    buttonIcon: {
                                                      kind: 'string',
                                                      required: false
                                                    },
                                                    buttonVariant: {
                                                      kind: 'enum',
                                                      required: false,
                                                      choices: [
                                                        'primary',
                                                        'secondary'
                                                      ]
                                                    },
                                                    helpText: {
                                                      kind: 'string',
                                                      required: false
                                                    }
                                                  }
                                                },
                                                {
                                                  kind: 'shape',
                                                  required: true,
                                                  fields: {
                                                    type: {
                                                      kind: 'string',
                                                      required: true,
                                                      value: 'MARKDOWN'
                                                    },
                                                    markdown: {
                                                      kind: 'string',
                                                      required: true
                                                    }
                                                  }
                                                },
                                                {
                                                  kind: 'shape',
                                                  required: true,
                                                  fields: {
                                                    type: {
                                                      kind: 'string',
                                                      required: true,
                                                      value: 'SHAPE'
                                                    },
                                                    sectionName: {
                                                      kind: 'string',
                                                      required: false
                                                    },
                                                    showDividerLine: {
                                                      kind: 'boolean',
                                                      required: false
                                                    },
                                                    conditional: {
                                                      kind: 'shape',
                                                      required: false,
                                                      fields: {
                                                        tagValue: {
                                                          kind: 'string',
                                                          required: true
                                                        },
                                                        configShapePath: {
                                                          kind: 'array',
                                                          required: true,
                                                          elementSpec: {
                                                            kind: 'string',
                                                            required: true
                                                          }
                                                        }
                                                      }
                                                    },
                                                    infoText: {
                                                      kind: 'string',
                                                      required: false
                                                    },
                                                    isCollapsible: {
                                                      kind: 'boolean',
                                                      required: false
                                                    },
                                                    numColumns: {
                                                      kind: 'integer',
                                                      required: false
                                                    },
                                                    fields: {
                                                      kind: 'array',
                                                      required: true,
                                                      elementSpec: {
                                                        kind: 'shape',
                                                        required: true,
                                                        fields: {
                                                          key: {
                                                            kind: 'string',
                                                            required: true
                                                          },
                                                          uiSchema: {
                                                            kind: 'taggedUnion',
                                                            required: true,
                                                            tagKey: 'type',
                                                            choices: [
                                                              {
                                                                kind: 'shape',
                                                                required: true,
                                                                fields: {
                                                                  type: {
                                                                    kind: 'string',
                                                                    required: true,
                                                                    value: 'FIELD'
                                                                  },
                                                                  displayName: {
                                                                    kind: 'string',
                                                                    required: false
                                                                  },
                                                                  editorOverride: {
                                                                    kind: 'enum',
                                                                    required: false,
                                                                    choices: [
                                                                      'CHECKBOX',
                                                                      'ICON_SELECTOR',
                                                                      'DATE_RANGE'
                                                                    ]
                                                                  },
                                                                  infoText: {
                                                                    kind: 'string',
                                                                    required: false
                                                                  },
                                                                  fieldSettings: {
                                                                    kind: 'taggedUnion',
                                                                    required: false,
                                                                    tagKey: 'type',
                                                                    choices: [
                                                                      {
                                                                        kind: 'shape',
                                                                        required: true,
                                                                        fields: {
                                                                          type: {
                                                                            kind: 'string',
                                                                            required: true,
                                                                            value: 'CHECKBOX_SETTINGS'
                                                                          },
                                                                          checkboxLabel: {
                                                                            kind: 'string',
                                                                            required: true
                                                                          }
                                                                        }
                                                                      },
                                                                      {
                                                                        kind: 'shape',
                                                                        required: true,
                                                                        fields: {
                                                                          type: {
                                                                            kind: 'string',
                                                                            required: true,
                                                                            value: 'COLUMN_REFERENCE_SETTINGS'
                                                                          },
                                                                          noColumnSelectedText: {
                                                                            kind: 'string',
                                                                            required: false
                                                                          },
                                                                          allowSelectNull: {
                                                                            kind: 'boolean',
                                                                            required: false
                                                                          },
                                                                          systemNameWildcardSelector: {
                                                                            kind: 'string',
                                                                            required: false
                                                                          },
                                                                          renderCyclingSelector: {
                                                                            kind: 'boolean',
                                                                            required: false
                                                                          }
                                                                        }
                                                                      },
                                                                      {
                                                                        kind: 'shape',
                                                                        required: true,
                                                                        fields: {
                                                                          type: {
                                                                            kind: 'string',
                                                                            required: true,
                                                                            value: 'COLUMN_VALUE_SETTINGS'
                                                                          },
                                                                          noValueSelectedText: {
                                                                            kind: 'string',
                                                                            required: false
                                                                          },
                                                                          renderCyclingSelector: {
                                                                            kind: 'boolean',
                                                                            required: false
                                                                          }
                                                                        }
                                                                      },
                                                                      {
                                                                        kind: 'shape',
                                                                        required: true,
                                                                        fields: {
                                                                          type: {
                                                                            kind: 'string',
                                                                            required: true,
                                                                            value: 'RANGE_SETTINGS'
                                                                          },
                                                                          startKey: {
                                                                            kind: 'string',
                                                                            required: true
                                                                          },
                                                                          endKey: {
                                                                            kind: 'string',
                                                                            required: true
                                                                          }
                                                                        }
                                                                      },
                                                                      {
                                                                        kind: 'shape',
                                                                        required: true,
                                                                        fields: {
                                                                          type: {
                                                                            kind: 'string',
                                                                            required: true,
                                                                            value: 'ENUM_SETTINGS'
                                                                          },
                                                                          displayNames: {
                                                                            kind: 'array',
                                                                            required: false,
                                                                            elementSpec: {
                                                                              kind: 'shape',
                                                                              required: true,
                                                                              fields: {
                                                                                value: {
                                                                                  kind: 'string',
                                                                                  required: true
                                                                                },
                                                                                displayName: {
                                                                                  kind: 'string',
                                                                                  required: true
                                                                                }
                                                                              }
                                                                            }
                                                                          },
                                                                          renderCyclingSelector: {
                                                                            kind: 'boolean',
                                                                            required: false
                                                                          }
                                                                        }
                                                                      },
                                                                      {
                                                                        kind: 'shape',
                                                                        required: true,
                                                                        fields: {
                                                                          type: {
                                                                            kind: 'string',
                                                                            required: true,
                                                                            value: 'ICON_SELECTOR_SETTINGS'
                                                                          },
                                                                          iconNames: {
                                                                            kind: 'array',
                                                                            required: false,
                                                                            elementSpec: {
                                                                              kind: 'shape',
                                                                              required: true,
                                                                              fields: {
                                                                                value: {
                                                                                  kind: 'string',
                                                                                  required: true
                                                                                },
                                                                                iconName: {
                                                                                  kind: 'string',
                                                                                  required: true
                                                                                }
                                                                              }
                                                                            }
                                                                          },
                                                                          displayNames: {
                                                                            kind: 'array',
                                                                            required: false,
                                                                            elementSpec: {
                                                                              kind: 'shape',
                                                                              required: true,
                                                                              fields: {
                                                                                value: {
                                                                                  kind: 'string',
                                                                                  required: true
                                                                                },
                                                                                displayName: {
                                                                                  kind: 'string',
                                                                                  required: true
                                                                                }
                                                                              }
                                                                            }
                                                                          },
                                                                          defaultValue: {
                                                                            kind: 'string',
                                                                            required: false
                                                                          }
                                                                        }
                                                                      },
                                                                      {
                                                                        kind: 'shape',
                                                                        required: true,
                                                                        fields: {
                                                                          type: {
                                                                            kind: 'string',
                                                                            required: true,
                                                                            value: 'TABLE_REFERENCE_SETTINGS'
                                                                          },
                                                                          disabledColumn: {
                                                                            kind: 'array',
                                                                            required: false,
                                                                            elementSpec: {
                                                                              kind: 'string',
                                                                              required: true
                                                                            }
                                                                          },
                                                                          hiddenColumn: {
                                                                            kind: 'array',
                                                                            required: false,
                                                                            elementSpec: {
                                                                              kind: 'string',
                                                                              required: true
                                                                            }
                                                                          }
                                                                        }
                                                                      },
                                                                      {
                                                                        kind: 'shape',
                                                                        required: true,
                                                                        fields: {
                                                                          type: {
                                                                            kind: 'string',
                                                                            required: true,
                                                                            value: 'TAGGED_UNION_SETTINGS'
                                                                          },
                                                                          tagKeyDisplayNames: {
                                                                            kind: 'array',
                                                                            required: false,
                                                                            elementSpec: {
                                                                              kind: 'shape',
                                                                              required: true,
                                                                              fields: {
                                                                                value: {
                                                                                  kind: 'string',
                                                                                  required: true
                                                                                },
                                                                                displayName: {
                                                                                  kind: 'string',
                                                                                  required: true
                                                                                }
                                                                              }
                                                                            }
                                                                          },
                                                                          renderCyclingSelector: {
                                                                            kind: 'boolean',
                                                                            required: false
                                                                          }
                                                                        }
                                                                      },
                                                                      {
                                                                        kind: 'shape',
                                                                        required: true,
                                                                        fields: {
                                                                          type: {
                                                                            kind: 'string',
                                                                            required: true,
                                                                            value: 'STRING_FIELD_SETTINGS'
                                                                          },
                                                                          useTextArea: {
                                                                            kind: 'boolean',
                                                                            required: false
                                                                          }
                                                                        }
                                                                      }
                                                                    ]
                                                                  }
                                                                }
                                                              },
                                                              {
                                                                kind: 'shape',
                                                                required: true,
                                                                fields: {
                                                                  type: {
                                                                    kind: 'string',
                                                                    required: true,
                                                                    value: 'ACTION_BUTTON'
                                                                  },
                                                                  action: {
                                                                    kind: 'enum',
                                                                    required: true,
                                                                    choices: [
                                                                      'RESET',
                                                                      'SUBMIT'
                                                                    ]
                                                                  },
                                                                  buttonText: {
                                                                    kind: 'string',
                                                                    required: true
                                                                  },
                                                                  buttonIcon: {
                                                                    kind: 'string',
                                                                    required: false
                                                                  },
                                                                  buttonVariant: {
                                                                    kind: 'enum',
                                                                    required: false,
                                                                    choices: [
                                                                      'primary',
                                                                      'secondary'
                                                                    ]
                                                                  },
                                                                  helpText: {
                                                                    kind: 'string',
                                                                    required: false
                                                                  }
                                                                }
                                                              },
                                                              {
                                                                kind: 'shape',
                                                                required: true,
                                                                fields: {
                                                                  type: {
                                                                    kind: 'string',
                                                                    required: true,
                                                                    value: 'MARKDOWN'
                                                                  },
                                                                  markdown: {
                                                                    kind: 'string',
                                                                    required: true
                                                                  }
                                                                }
                                                              }
                                                            ]
                                                          }
                                                        }
                                                      },
                                                      minItems: 1
                                                    }
                                                  }
                                                }
                                              ]
                                            }
                                          }
                                        },
                                        minItems: 1
                                      }
                                    }
                                  }
                                }
                              },
                              {
                                kind: 'shape',
                                required: true,
                                fields: {
                                  type: {
                                    kind: 'string',
                                    required: true,
                                    value: 'MARKDOWN'
                                  },
                                  markdown: {
                                    kind: 'string',
                                    required: true
                                  },
                                  blockConfig: {
                                    kind: 'taggedUnion',
                                    required: false,
                                    tagKey: 'blockMode',
                                    choices: [
                                      {
                                        kind: 'shape',
                                        required: true,
                                        fields: {
                                          blockMode: {
                                            kind: 'string',
                                            required: true,
                                            value: 'PANE'
                                          },
                                          title: {
                                            kind: 'string',
                                            required: false
                                          },
                                          subtitle: {
                                            kind: 'string',
                                            required: false
                                          },
                                          infoText: {
                                            kind: 'string',
                                            required: false
                                          },
                                          isCollapsible: {
                                            kind: 'boolean',
                                            required: false
                                          }
                                        }
                                      },
                                      {
                                        kind: 'shape',
                                        required: true,
                                        fields: {
                                          blockMode: {
                                            kind: 'string',
                                            required: true,
                                            value: 'CONTENT_ONLY'
                                          },
                                          isCollapsible: {
                                            kind: 'boolean',
                                            required: false
                                          }
                                        }
                                      }
                                    ]
                                  }
                                }
                              },
                              {
                                kind: 'shape',
                                required: true,
                                fields: {
                                  type: {
                                    kind: 'string',
                                    required: true,
                                    value: 'NESTED_GRID'
                                  },
                                  gridMode: {
                                    kind: 'enum',
                                    required: false,
                                    choices: [
                                      'SEPARATED',
                                      'COMBINED'
                                    ]
                                  },
                                  rows: {
                                    kind: 'array',
                                    required: true,
                                    elementSpec: {
                                      kind: 'array',
                                      required: true,
                                      elementSpec: {
                                        kind: 'taggedUnion',
                                        required: true,
                                        tagKey: 'type',
                                        choices: [
                                          {
                                            kind: 'shape',
                                            required: true,
                                            fields: {
                                              type: {
                                                kind: 'string',
                                                required: true,
                                                value: 'DATA'
                                              },
                                              inputReference: {
                                                kind: 'shape',
                                                required: true,
                                                fields: {
                                                  inputDataName: {
                                                    kind: 'enum',
                                                    required: true,
                                                    choices: [
                                                      'Input datasets',
                                                      'Input charts',
                                                      'Input files'
                                                    ]
                                                  },
                                                  inputDataIndex: {
                                                    kind: 'integer',
                                                    required: true
                                                  }
                                                }
                                              },
                                              blockConfig: {
                                                kind: 'taggedUnion',
                                                required: false,
                                                tagKey: 'blockMode',
                                                choices: [
                                                  {
                                                    kind: 'shape',
                                                    required: true,
                                                    fields: {
                                                      blockMode: {
                                                        kind: 'string',
                                                        required: true,
                                                        value: 'PANE'
                                                      },
                                                      title: {
                                                        kind: 'string',
                                                        required: false
                                                      },
                                                      subtitle: {
                                                        kind: 'string',
                                                        required: false
                                                      },
                                                      infoText: {
                                                        kind: 'string',
                                                        required: false
                                                      },
                                                      isCollapsible: {
                                                        kind: 'boolean',
                                                        required: false
                                                      }
                                                    }
                                                  },
                                                  {
                                                    kind: 'shape',
                                                    required: true,
                                                    fields: {
                                                      blockMode: {
                                                        kind: 'string',
                                                        required: true,
                                                        value: 'CONTENT_ONLY'
                                                      },
                                                      isCollapsible: {
                                                        kind: 'boolean',
                                                        required: false
                                                      }
                                                    }
                                                  }
                                                ]
                                              },
                                              tableConfig: {
                                                kind: 'shape',
                                                required: false,
                                                fields: {
                                                  tableMode: {
                                                    kind: 'enum',
                                                    required: false,
                                                    choices: [
                                                      'TEXT',
                                                      'RICH'
                                                    ]
                                                  }
                                                }
                                              }
                                            }
                                          },
                                          {
                                            kind: 'shape',
                                            required: true,
                                            fields: {
                                              type: {
                                                kind: 'string',
                                                required: true,
                                                value: 'CONFIG_FORM'
                                              },
                                              blockConfig: {
                                                kind: 'taggedUnion',
                                                required: false,
                                                tagKey: 'blockMode',
                                                choices: [
                                                  {
                                                    kind: 'shape',
                                                    required: true,
                                                    fields: {
                                                      blockMode: {
                                                        kind: 'string',
                                                        required: true,
                                                        value: 'PANE'
                                                      },
                                                      title: {
                                                        kind: 'string',
                                                        required: false
                                                      },
                                                      subtitle: {
                                                        kind: 'string',
                                                        required: false
                                                      },
                                                      infoText: {
                                                        kind: 'string',
                                                        required: false
                                                      },
                                                      isCollapsible: {
                                                        kind: 'boolean',
                                                        required: false
                                                      }
                                                    }
                                                  },
                                                  {
                                                    kind: 'shape',
                                                    required: true,
                                                    fields: {
                                                      blockMode: {
                                                        kind: 'string',
                                                        required: true,
                                                        value: 'CONTENT_ONLY'
                                                      },
                                                      isCollapsible: {
                                                        kind: 'boolean',
                                                        required: false
                                                      }
                                                    }
                                                  }
                                                ]
                                              },
                                              configFields: {
                                                kind: 'array',
                                                required: true,
                                                elementSpec: {
                                                  kind: 'shape',
                                                  required: true,
                                                  fields: {
                                                    key: {
                                                      kind: 'string',
                                                      required: true
                                                    },
                                                    configReferences: {
                                                      kind: 'array',
                                                      required: true,
                                                      elementSpec: {
                                                        kind: 'shape',
                                                        required: true,
                                                        fields: {
                                                          inputDataName: {
                                                            kind: 'enum',
                                                            required: true,
                                                            choices: [
                                                              'Input datasets',
                                                              'Input charts',
                                                              'Input files'
                                                            ]
                                                          },
                                                          inputDataIndex: {
                                                            kind: 'integer',
                                                            required: true
                                                          },
                                                          configPath: {
                                                            kind: 'array',
                                                            required: true,
                                                            elementSpec: {
                                                              kind: 'anything',
                                                              required: true
                                                            }
                                                          }
                                                        }
                                                      },
                                                      minItems: 1
                                                    },
                                                    configSpec: {
                                                      kind: 'taggedUnion',
                                                      required: true,
                                                      tagKey: 'kind',
                                                      choices: [
                                                        {
                                                          kind: 'shape',
                                                          required: true,
                                                          fields: {
                                                            kind: {
                                                              kind: 'string',
                                                              required: true,
                                                              value: 'boolean'
                                                            },
                                                            required: {
                                                              kind: 'boolean',
                                                              required: true
                                                            }
                                                          }
                                                        },
                                                        {
                                                          kind: 'shape',
                                                          required: true,
                                                          fields: {
                                                            kind: {
                                                              kind: 'string',
                                                              required: true,
                                                              value: 'columnReference'
                                                            },
                                                            inputDataName: {
                                                              kind: 'string',
                                                              required: true
                                                            },
                                                            validationOptions: {
                                                              kind: 'shape',
                                                              required: false,
                                                              fields: {
                                                                allowedLeafTypes: {
                                                                  kind: 'array',
                                                                  required: false,
                                                                  elementSpec: {
                                                                    kind: 'enum',
                                                                    required: true,
                                                                    choices: [
                                                                      'BOOLEAN',
                                                                      'DATETIME',
                                                                      'DATE',
                                                                      'DECIMAL',
                                                                      'INTEGER',
                                                                      'JSON',
                                                                      'TEXT',
                                                                      'BENCHLING_OBJECT',
                                                                      'BLOB',
                                                                      'CHART',
                                                                      'FILE',
                                                                      'SCRATCH_FILE',
                                                                      'DATA_FRAME',
                                                                      'DATASET',
                                                                      'DROPDOWN_OPTION',
                                                                      'BATCH',
                                                                      'BIOENTITY',
                                                                      'BASIC_FOLDER_ITEM',
                                                                      'MIXTURE',
                                                                      'MOLECULE',
                                                                      'PROTEIN',
                                                                      'SEQUENCE',
                                                                      'ENTRY',
                                                                      'PROTOCOL',
                                                                      'REQUEST',
                                                                      'RESULT',
                                                                      'RUN',
                                                                      'STORABLE',
                                                                      'BOX',
                                                                      'CONTAINER',
                                                                      'LOCATION',
                                                                      'PLATE',
                                                                      'PROCESS',
                                                                      'PROCESS_TASK',
                                                                      'PROCESS_OUTPUT',
                                                                      'STUDY',
                                                                      'TEAM',
                                                                      'TEST_ORDER',
                                                                      'USER'
                                                                    ]
                                                                  }
                                                                },
                                                                listType: {
                                                                  kind: 'enum',
                                                                  required: false,
                                                                  choices: [
                                                                    'ALLOWED',
                                                                    'REQUIRED',
                                                                    'NOT_ALLOWED'
                                                                  ]
                                                                },
                                                                nullableType: {
                                                                  kind: 'enum',
                                                                  required: false,
                                                                  choices: [
                                                                    'ALLOWED',
                                                                    'REQUIRED',
                                                                    'NOT_ALLOWED'
                                                                  ]
                                                                }
                                                              }
                                                            },
                                                            required: {
                                                              kind: 'boolean',
                                                              required: true
                                                            }
                                                          }
                                                        },
                                                        {
                                                          kind: 'shape',
                                                          required: true,
                                                          fields: {
                                                            kind: {
                                                              kind: 'string',
                                                              required: true,
                                                              value: 'columnValue'
                                                            },
                                                            columnSystemName: {
                                                              kind: 'string',
                                                              required: true
                                                            },
                                                            inputDataName: {
                                                              kind: 'string',
                                                              required: true
                                                            },
                                                            inputDataIndex: {
                                                              kind: 'integer',
                                                              required: true
                                                            },
                                                            required: {
                                                              kind: 'boolean',
                                                              required: true
                                                            }
                                                          }
                                                        },
                                                        {
                                                          kind: 'shape',
                                                          required: true,
                                                          fields: {
                                                            kind: {
                                                              kind: 'string',
                                                              required: true,
                                                              value: 'date'
                                                            },
                                                            required: {
                                                              kind: 'boolean',
                                                              required: true
                                                            }
                                                          }
                                                        },
                                                        {
                                                          kind: 'shape',
                                                          required: true,
                                                          fields: {
                                                            kind: {
                                                              kind: 'string',
                                                              required: true,
                                                              value: 'enum'
                                                            },
                                                            choices: {
                                                              kind: 'array',
                                                              required: true,
                                                              elementSpec: {
                                                                kind: 'string',
                                                                required: true
                                                              }
                                                            },
                                                            required: {
                                                              kind: 'boolean',
                                                              required: true
                                                            }
                                                          }
                                                        },
                                                        {
                                                          kind: 'shape',
                                                          required: true,
                                                          fields: {
                                                            kind: {
                                                              kind: 'string',
                                                              required: true,
                                                              value: 'integer'
                                                            },
                                                            minValue: {
                                                              kind: 'integer',
                                                              required: false
                                                            },
                                                            maxValue: {
                                                              kind: 'integer',
                                                              required: false
                                                            },
                                                            required: {
                                                              kind: 'boolean',
                                                              required: true
                                                            }
                                                          }
                                                        },
                                                        {
                                                          kind: 'shape',
                                                          required: true,
                                                          fields: {
                                                            kind: {
                                                              kind: 'string',
                                                              required: true,
                                                              value: 'number'
                                                            },
                                                            required: {
                                                              kind: 'boolean',
                                                              required: true
                                                            }
                                                          }
                                                        },
                                                        {
                                                          kind: 'shape',
                                                          required: true,
                                                          fields: {
                                                            kind: {
                                                              kind: 'string',
                                                              required: true,
                                                              value: 'string'
                                                            },
                                                            value: {
                                                              kind: 'string',
                                                              required: false
                                                            },
                                                            pattern: {
                                                              kind: 'string',
                                                              required: false
                                                            },
                                                            required: {
                                                              kind: 'boolean',
                                                              required: true
                                                            }
                                                          }
                                                        },
                                                        {
                                                          kind: 'shape',
                                                          required: true,
                                                          fields: {
                                                            kind: {
                                                              kind: 'string',
                                                              required: true,
                                                              value: 'tableReference'
                                                            },
                                                            inputDataName: {
                                                              kind: 'string',
                                                              required: true
                                                            },
                                                            inputDataIndex: {
                                                              kind: 'integer',
                                                              required: true
                                                            },
                                                            required: {
                                                              kind: 'boolean',
                                                              required: true
                                                            }
                                                          }
                                                        }
                                                      ]
                                                    }
                                                  }
                                                }
                                              },
                                              uiSchema: {
                                                kind: 'shape',
                                                required: true,
                                                fields: {
                                                  type: {
                                                    kind: 'string',
                                                    required: true,
                                                    value: 'SHAPE'
                                                  },
                                                  sectionName: {
                                                    kind: 'string',
                                                    required: false
                                                  },
                                                  showDividerLine: {
                                                    kind: 'boolean',
                                                    required: false
                                                  },
                                                  conditional: {
                                                    kind: 'shape',
                                                    required: false,
                                                    fields: {
                                                      tagValue: {
                                                        kind: 'string',
                                                        required: true
                                                      },
                                                      configShapePath: {
                                                        kind: 'array',
                                                        required: true,
                                                        elementSpec: {
                                                          kind: 'string',
                                                          required: true
                                                        }
                                                      }
                                                    }
                                                  },
                                                  infoText: {
                                                    kind: 'string',
                                                    required: false
                                                  },
                                                  isCollapsible: {
                                                    kind: 'boolean',
                                                    required: false
                                                  },
                                                  numColumns: {
                                                    kind: 'integer',
                                                    required: false
                                                  },
                                                  fields: {
                                                    kind: 'array',
                                                    required: true,
                                                    elementSpec: {
                                                      kind: 'shape',
                                                      required: true,
                                                      fields: {
                                                        key: {
                                                          kind: 'string',
                                                          required: true
                                                        },
                                                        uiSchema: {
                                                          kind: 'taggedUnion',
                                                          required: true,
                                                          tagKey: 'type',
                                                          choices: [
                                                            {
                                                              kind: 'shape',
                                                              required: true,
                                                              fields: {
                                                                type: {
                                                                  kind: 'string',
                                                                  required: true,
                                                                  value: 'FIELD'
                                                                },
                                                                displayName: {
                                                                  kind: 'string',
                                                                  required: false
                                                                },
                                                                editorOverride: {
                                                                  kind: 'enum',
                                                                  required: false,
                                                                  choices: [
                                                                    'CHECKBOX',
                                                                    'ICON_SELECTOR',
                                                                    'DATE_RANGE'
                                                                  ]
                                                                },
                                                                infoText: {
                                                                  kind: 'string',
                                                                  required: false
                                                                },
                                                                fieldSettings: {
                                                                  kind: 'taggedUnion',
                                                                  required: false,
                                                                  tagKey: 'type',
                                                                  choices: [
                                                                    {
                                                                      kind: 'shape',
                                                                      required: true,
                                                                      fields: {
                                                                        type: {
                                                                          kind: 'string',
                                                                          required: true,
                                                                          value: 'CHECKBOX_SETTINGS'
                                                                        },
                                                                        checkboxLabel: {
                                                                          kind: 'string',
                                                                          required: true
                                                                        }
                                                                      }
                                                                    },
                                                                    {
                                                                      kind: 'shape',
                                                                      required: true,
                                                                      fields: {
                                                                        type: {
                                                                          kind: 'string',
                                                                          required: true,
                                                                          value: 'COLUMN_REFERENCE_SETTINGS'
                                                                        },
                                                                        noColumnSelectedText: {
                                                                          kind: 'string',
                                                                          required: false
                                                                        },
                                                                        allowSelectNull: {
                                                                          kind: 'boolean',
                                                                          required: false
                                                                        },
                                                                        systemNameWildcardSelector: {
                                                                          kind: 'string',
                                                                          required: false
                                                                        },
                                                                        renderCyclingSelector: {
                                                                          kind: 'boolean',
                                                                          required: false
                                                                        }
                                                                      }
                                                                    },
                                                                    {
                                                                      kind: 'shape',
                                                                      required: true,
                                                                      fields: {
                                                                        type: {
                                                                          kind: 'string',
                                                                          required: true,
                                                                          value: 'COLUMN_VALUE_SETTINGS'
                                                                        },
                                                                        noValueSelectedText: {
                                                                          kind: 'string',
                                                                          required: false
                                                                        },
                                                                        renderCyclingSelector: {
                                                                          kind: 'boolean',
                                                                          required: false
                                                                        }
                                                                      }
                                                                    },
                                                                    {
                                                                      kind: 'shape',
                                                                      required: true,
                                                                      fields: {
                                                                        type: {
                                                                          kind: 'string',
                                                                          required: true,
                                                                          value: 'RANGE_SETTINGS'
                                                                        },
                                                                        startKey: {
                                                                          kind: 'string',
                                                                          required: true
                                                                        },
                                                                        endKey: {
                                                                          kind: 'string',
                                                                          required: true
                                                                        }
                                                                      }
                                                                    },
                                                                    {
                                                                      kind: 'shape',
                                                                      required: true,
                                                                      fields: {
                                                                        type: {
                                                                          kind: 'string',
                                                                          required: true,
                                                                          value: 'ENUM_SETTINGS'
                                                                        },
                                                                        displayNames: {
                                                                          kind: 'array',
                                                                          required: false,
                                                                          elementSpec: {
                                                                            kind: 'shape',
                                                                            required: true,
                                                                            fields: {
                                                                              value: {
                                                                                kind: 'string',
                                                                                required: true
                                                                              },
                                                                              displayName: {
                                                                                kind: 'string',
                                                                                required: true
                                                                              }
                                                                            }
                                                                          }
                                                                        },
                                                                        renderCyclingSelector: {
                                                                          kind: 'boolean',
                                                                          required: false
                                                                        }
                                                                      }
                                                                    },
                                                                    {
                                                                      kind: 'shape',
                                                                      required: true,
                                                                      fields: {
                                                                        type: {
                                                                          kind: 'string',
                                                                          required: true,
                                                                          value: 'ICON_SELECTOR_SETTINGS'
                                                                        },
                                                                        iconNames: {
                                                                          kind: 'array',
                                                                          required: false,
                                                                          elementSpec: {
                                                                            kind: 'shape',
                                                                            required: true,
                                                                            fields: {
                                                                              value: {
                                                                                kind: 'string',
                                                                                required: true
                                                                              },
                                                                              iconName: {
                                                                                kind: 'string',
                                                                                required: true
                                                                              }
                                                                            }
                                                                          }
                                                                        },
                                                                        displayNames: {
                                                                          kind: 'array',
                                                                          required: false,
                                                                          elementSpec: {
                                                                            kind: 'shape',
                                                                            required: true,
                                                                            fields: {
                                                                              value: {
                                                                                kind: 'string',
                                                                                required: true
                                                                              },
                                                                              displayName: {
                                                                                kind: 'string',
                                                                                required: true
                                                                              }
                                                                            }
                                                                          }
                                                                        },
                                                                        defaultValue: {
                                                                          kind: 'string',
                                                                          required: false
                                                                        }
                                                                      }
                                                                    },
                                                                    {
                                                                      kind: 'shape',
                                                                      required: true,
                                                                      fields: {
                                                                        type: {
                                                                          kind: 'string',
                                                                          required: true,
                                                                          value: 'TABLE_REFERENCE_SETTINGS'
                                                                        },
                                                                        disabledColumn: {
                                                                          kind: 'array',
                                                                          required: false,
                                                                          elementSpec: {
                                                                            kind: 'string',
                                                                            required: true
                                                                          }
                                                                        },
                                                                        hiddenColumn: {
                                                                          kind: 'array',
                                                                          required: false,
                                                                          elementSpec: {
                                                                            kind: 'string',
                                                                            required: true
                                                                          }
                                                                        }
                                                                      }
                                                                    },
                                                                    {
                                                                      kind: 'shape',
                                                                      required: true,
                                                                      fields: {
                                                                        type: {
                                                                          kind: 'string',
                                                                          required: true,
                                                                          value: 'TAGGED_UNION_SETTINGS'
                                                                        },
                                                                        tagKeyDisplayNames: {
                                                                          kind: 'array',
                                                                          required: false,
                                                                          elementSpec: {
                                                                            kind: 'shape',
                                                                            required: true,
                                                                            fields: {
                                                                              value: {
                                                                                kind: 'string',
                                                                                required: true
                                                                              },
                                                                              displayName: {
                                                                                kind: 'string',
                                                                                required: true
                                                                              }
                                                                            }
                                                                          }
                                                                        },
                                                                        renderCyclingSelector: {
                                                                          kind: 'boolean',
                                                                          required: false
                                                                        }
                                                                      }
                                                                    },
                                                                    {
                                                                      kind: 'shape',
                                                                      required: true,
                                                                      fields: {
                                                                        type: {
                                                                          kind: 'string',
                                                                          required: true,
                                                                          value: 'STRING_FIELD_SETTINGS'
                                                                        },
                                                                        useTextArea: {
                                                                          kind: 'boolean',
                                                                          required: false
                                                                        }
                                                                      }
                                                                    }
                                                                  ]
                                                                }
                                                              }
                                                            },
                                                            {
                                                              kind: 'shape',
                                                              required: true,
                                                              fields: {
                                                                type: {
                                                                  kind: 'string',
                                                                  required: true,
                                                                  value: 'ACTION_BUTTON'
                                                                },
                                                                action: {
                                                                  kind: 'enum',
                                                                  required: true,
                                                                  choices: [
                                                                    'RESET',
                                                                    'SUBMIT'
                                                                  ]
                                                                },
                                                                buttonText: {
                                                                  kind: 'string',
                                                                  required: true
                                                                },
                                                                buttonIcon: {
                                                                  kind: 'string',
                                                                  required: false
                                                                },
                                                                buttonVariant: {
                                                                  kind: 'enum',
                                                                  required: false,
                                                                  choices: [
                                                                    'primary',
                                                                    'secondary'
                                                                  ]
                                                                },
                                                                helpText: {
                                                                  kind: 'string',
                                                                  required: false
                                                                }
                                                              }
                                                            },
                                                            {
                                                              kind: 'shape',
                                                              required: true,
                                                              fields: {
                                                                type: {
                                                                  kind: 'string',
                                                                  required: true,
                                                                  value: 'MARKDOWN'
                                                                },
                                                                markdown: {
                                                                  kind: 'string',
                                                                  required: true
                                                                }
                                                              }
                                                            },
                                                            {
                                                              kind: 'shape',
                                                              required: true,
                                                              fields: {
                                                                type: {
                                                                  kind: 'string',
                                                                  required: true,
                                                                  value: 'SHAPE'
                                                                },
                                                                sectionName: {
                                                                  kind: 'string',
                                                                  required: false
                                                                },
                                                                showDividerLine: {
                                                                  kind: 'boolean',
                                                                  required: false
                                                                },
                                                                conditional: {
                                                                  kind: 'shape',
                                                                  required: false,
                                                                  fields: {
                                                                    tagValue: {
                                                                      kind: 'string',
                                                                      required: true
                                                                    },
                                                                    configShapePath: {
                                                                      kind: 'array',
                                                                      required: true,
                                                                      elementSpec: {
                                                                        kind: 'string',
                                                                        required: true
                                                                      }
                                                                    }
                                                                  }
                                                                },
                                                                infoText: {
                                                                  kind: 'string',
                                                                  required: false
                                                                },
                                                                isCollapsible: {
                                                                  kind: 'boolean',
                                                                  required: false
                                                                },
                                                                numColumns: {
                                                                  kind: 'integer',
                                                                  required: false
                                                                },
                                                                fields: {
                                                                  kind: 'array',
                                                                  required: true,
                                                                  elementSpec: {
                                                                    kind: 'shape',
                                                                    required: true,
                                                                    fields: {
                                                                      key: {
                                                                        kind: 'string',
                                                                        required: true
                                                                      },
                                                                      uiSchema: {
                                                                        kind: 'taggedUnion',
                                                                        required: true,
                                                                        tagKey: 'type',
                                                                        choices: [
                                                                          {
                                                                            kind: 'shape',
                                                                            required: true,
                                                                            fields: {
                                                                              type: {
                                                                                kind: 'string',
                                                                                required: true,
                                                                                value: 'FIELD'
                                                                              },
                                                                              displayName: {
                                                                                kind: 'string',
                                                                                required: false
                                                                              },
                                                                              editorOverride: {
                                                                                kind: 'enum',
                                                                                required: false,
                                                                                choices: [
                                                                                  'CHECKBOX',
                                                                                  'ICON_SELECTOR',
                                                                                  'DATE_RANGE'
                                                                                ]
                                                                              },
                                                                              infoText: {
                                                                                kind: 'string',
                                                                                required: false
                                                                              },
                                                                              fieldSettings: {
                                                                                kind: 'taggedUnion',
                                                                                required: false,
                                                                                tagKey: 'type',
                                                                                choices: [
                                                                                  {
                                                                                    kind: 'shape',
                                                                                    required: true,
                                                                                    fields: {
                                                                                      type: {
                                                                                        kind: 'string',
                                                                                        required: true,
                                                                                        value: 'CHECKBOX_SETTINGS'
                                                                                      },
                                                                                      checkboxLabel: {
                                                                                        kind: 'string',
                                                                                        required: true
                                                                                      }
                                                                                    }
                                                                                  },
                                                                                  {
                                                                                    kind: 'shape',
                                                                                    required: true,
                                                                                    fields: {
                                                                                      type: {
                                                                                        kind: 'string',
                                                                                        required: true,
                                                                                        value: 'COLUMN_REFERENCE_SETTINGS'
                                                                                      },
                                                                                      noColumnSelectedText: {
                                                                                        kind: 'string',
                                                                                        required: false
                                                                                      },
                                                                                      allowSelectNull: {
                                                                                        kind: 'boolean',
                                                                                        required: false
                                                                                      },
                                                                                      systemNameWildcardSelector: {
                                                                                        kind: 'string',
                                                                                        required: false
                                                                                      },
                                                                                      renderCyclingSelector: {
                                                                                        kind: 'boolean',
                                                                                        required: false
                                                                                      }
                                                                                    }
                                                                                  },
                                                                                  {
                                                                                    kind: 'shape',
                                                                                    required: true,
                                                                                    fields: {
                                                                                      type: {
                                                                                        kind: 'string',
                                                                                        required: true,
                                                                                        value: 'COLUMN_VALUE_SETTINGS'
                                                                                      },
                                                                                      noValueSelectedText: {
                                                                                        kind: 'string',
                                                                                        required: false
                                                                                      },
                                                                                      renderCyclingSelector: {
                                                                                        kind: 'boolean',
                                                                                        required: false
                                                                                      }
                                                                                    }
                                                                                  },
                                                                                  {
                                                                                    kind: 'shape',
                                                                                    required: true,
                                                                                    fields: {
                                                                                      type: {
                                                                                        kind: 'string',
                                                                                        required: true,
                                                                                        value: 'RANGE_SETTINGS'
                                                                                      },
                                                                                      startKey: {
                                                                                        kind: 'string',
                                                                                        required: true
                                                                                      },
                                                                                      endKey: {
                                                                                        kind: 'string',
                                                                                        required: true
                                                                                      }
                                                                                    }
                                                                                  },
                                                                                  {
                                                                                    kind: 'shape',
                                                                                    required: true,
                                                                                    fields: {
                                                                                      type: {
                                                                                        kind: 'string',
                                                                                        required: true,
                                                                                        value: 'ENUM_SETTINGS'
                                                                                      },
                                                                                      displayNames: {
                                                                                        kind: 'array',
                                                                                        required: false,
                                                                                        elementSpec: {
                                                                                          kind: 'shape',
                                                                                          required: true,
                                                                                          fields: {
                                                                                            value: {
                                                                                              kind: 'string',
                                                                                              required: true
                                                                                            },
                                                                                            displayName: {
                                                                                              kind: 'string',
                                                                                              required: true
                                                                                            }
                                                                                          }
                                                                                        }
                                                                                      },
                                                                                      renderCyclingSelector: {
                                                                                        kind: 'boolean',
                                                                                        required: false
                                                                                      }
                                                                                    }
                                                                                  },
                                                                                  {
                                                                                    kind: 'shape',
                                                                                    required: true,
                                                                                    fields: {
                                                                                      type: {
                                                                                        kind: 'string',
                                                                                        required: true,
                                                                                        value: 'ICON_SELECTOR_SETTINGS'
                                                                                      },
                                                                                      iconNames: {
                                                                                        kind: 'array',
                                                                                        required: false,
                                                                                        elementSpec: {
                                                                                          kind: 'shape',
                                                                                          required: true,
                                                                                          fields: {
                                                                                            value: {
                                                                                              kind: 'string',
                                                                                              required: true
                                                                                            },
                                                                                            iconName: {
                                                                                              kind: 'string',
                                                                                              required: true
                                                                                            }
                                                                                          }
                                                                                        }
                                                                                      },
                                                                                      displayNames: {
                                                                                        kind: 'array',
                                                                                        required: false,
                                                                                        elementSpec: {
                                                                                          kind: 'shape',
                                                                                          required: true,
                                                                                          fields: {
                                                                                            value: {
                                                                                              kind: 'string',
                                                                                              required: true
                                                                                            },
                                                                                            displayName: {
                                                                                              kind: 'string',
                                                                                              required: true
                                                                                            }
                                                                                          }
                                                                                        }
                                                                                      },
                                                                                      defaultValue: {
                                                                                        kind: 'string',
                                                                                        required: false
                                                                                      }
                                                                                    }
                                                                                  },
                                                                                  {
                                                                                    kind: 'shape',
                                                                                    required: true,
                                                                                    fields: {
                                                                                      type: {
                                                                                        kind: 'string',
                                                                                        required: true,
                                                                                        value: 'TABLE_REFERENCE_SETTINGS'
                                                                                      },
                                                                                      disabledColumn: {
                                                                                        kind: 'array',
                                                                                        required: false,
                                                                                        elementSpec: {
                                                                                          kind: 'string',
                                                                                          required: true
                                                                                        }
                                                                                      },
                                                                                      hiddenColumn: {
                                                                                        kind: 'array',
                                                                                        required: false,
                                                                                        elementSpec: {
                                                                                          kind: 'string',
                                                                                          required: true
                                                                                        }
                                                                                      }
                                                                                    }
                                                                                  },
                                                                                  {
                                                                                    kind: 'shape',
                                                                                    required: true,
                                                                                    fields: {
                                                                                      type: {
                                                                                        kind: 'string',
                                                                                        required: true,
                                                                                        value: 'TAGGED_UNION_SETTINGS'
                                                                                      },
                                                                                      tagKeyDisplayNames: {
                                                                                        kind: 'array',
                                                                                        required: false,
                                                                                        elementSpec: {
                                                                                          kind: 'shape',
                                                                                          required: true,
                                                                                          fields: {
                                                                                            value: {
                                                                                              kind: 'string',
                                                                                              required: true
                                                                                            },
                                                                                            displayName: {
                                                                                              kind: 'string',
                                                                                              required: true
                                                                                            }
                                                                                          }
                                                                                        }
                                                                                      },
                                                                                      renderCyclingSelector: {
                                                                                        kind: 'boolean',
                                                                                        required: false
                                                                                      }
                                                                                    }
                                                                                  },
                                                                                  {
                                                                                    kind: 'shape',
                                                                                    required: true,
                                                                                    fields: {
                                                                                      type: {
                                                                                        kind: 'string',
                                                                                        required: true,
                                                                                        value: 'STRING_FIELD_SETTINGS'
                                                                                      },
                                                                                      useTextArea: {
                                                                                        kind: 'boolean',
                                                                                        required: false
                                                                                      }
                                                                                    }
                                                                                  }
                                                                                ]
                                                                              }
                                                                            }
                                                                          },
                                                                          {
                                                                            kind: 'shape',
                                                                            required: true,
                                                                            fields: {
                                                                              type: {
                                                                                kind: 'string',
                                                                                required: true,
                                                                                value: 'ACTION_BUTTON'
                                                                              },
                                                                              action: {
                                                                                kind: 'enum',
                                                                                required: true,
                                                                                choices: [
                                                                                  'RESET',
                                                                                  'SUBMIT'
                                                                                ]
                                                                              },
                                                                              buttonText: {
                                                                                kind: 'string',
                                                                                required: true
                                                                              },
                                                                              buttonIcon: {
                                                                                kind: 'string',
                                                                                required: false
                                                                              },
                                                                              buttonVariant: {
                                                                                kind: 'enum',
                                                                                required: false,
                                                                                choices: [
                                                                                  'primary',
                                                                                  'secondary'
                                                                                ]
                                                                              },
                                                                              helpText: {
                                                                                kind: 'string',
                                                                                required: false
                                                                              }
                                                                            }
                                                                          },
                                                                          {
                                                                            kind: 'shape',
                                                                            required: true,
                                                                            fields: {
                                                                              type: {
                                                                                kind: 'string',
                                                                                required: true,
                                                                                value: 'MARKDOWN'
                                                                              },
                                                                              markdown: {
                                                                                kind: 'string',
                                                                                required: true
                                                                              }
                                                                            }
                                                                          }
                                                                        ]
                                                                      }
                                                                    }
                                                                  },
                                                                  minItems: 1
                                                                }
                                                              }
                                                            }
                                                          ]
                                                        }
                                                      }
                                                    },
                                                    minItems: 1
                                                  }
                                                }
                                              }
                                            }
                                          },
                                          {
                                            kind: 'shape',
                                            required: true,
                                            fields: {
                                              type: {
                                                kind: 'string',
                                                required: true,
                                                value: 'MARKDOWN'
                                              },
                                              markdown: {
                                                kind: 'string',
                                                required: true
                                              },
                                              blockConfig: {
                                                kind: 'taggedUnion',
                                                required: false,
                                                tagKey: 'blockMode',
                                                choices: [
                                                  {
                                                    kind: 'shape',
                                                    required: true,
                                                    fields: {
                                                      blockMode: {
                                                        kind: 'string',
                                                        required: true,
                                                        value: 'PANE'
                                                      },
                                                      title: {
                                                        kind: 'string',
                                                        required: false
                                                      },
                                                      subtitle: {
                                                        kind: 'string',
                                                        required: false
                                                      },
                                                      infoText: {
                                                        kind: 'string',
                                                        required: false
                                                      },
                                                      isCollapsible: {
                                                        kind: 'boolean',
                                                        required: false
                                                      }
                                                    }
                                                  },
                                                  {
                                                    kind: 'shape',
                                                    required: true,
                                                    fields: {
                                                      blockMode: {
                                                        kind: 'string',
                                                        required: true,
                                                        value: 'CONTENT_ONLY'
                                                      },
                                                      isCollapsible: {
                                                        kind: 'boolean',
                                                        required: false
                                                      }
                                                    }
                                                  }
                                                ]
                                              }
                                            }
                                          },
                                          {
                                            kind: 'shape',
                                            required: true,
                                            fields: {
                                              type: {
                                                kind: 'string',
                                                required: true,
                                                value: 'PLACEHOLDER'
                                              }
                                            }
                                          }
                                        ]
                                      }
                                    }
                                  }
                                }
                              },
                              {
                                kind: 'shape',
                                required: true,
                                fields: {
                                  type: {
                                    kind: 'string',
                                    required: true,
                                    value: 'PLACEHOLDER'
                                  }
                                }
                              }
                            ]
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          ]
        }
      },
      statusDependencies: {
        kind: 'array',
        required: false,
        elementSpec: {
          kind: 'shape',
          required: true,
          fields: {
            inputReferences: {
              kind: 'array',
              required: true,
              elementSpec: {
                kind: 'shape',
                required: true,
                fields: {
                  inputDataName: {
                    kind: 'enum',
                    required: true,
                    choices: [
                      'Input datasets',
                      'Input charts',
                      'Input files'
                    ]
                  },
                  inputDataIndex: {
                    kind: 'integer',
                    required: true
                  }
                }
              }
            },
            runningMessage: {
              kind: 'string',
              required: true
            },
            failureMessage: {
              kind: 'string',
              required: true
            }
          }
        }
      },
      sidebarParent: {
        kind: 'shape',
        required: false,
        fields: {
          inputDataName: {
            kind: 'enum',
            required: true,
            choices: [
              'Input datasets',
              'Input charts',
              'Input files'
            ]
          },
          inputDataIndex: {
            kind: 'integer',
            required: true
          }
        }
      },
      sidebarGrouping: {
        kind: 'shape',
        required: false,
        fields: {
          key: {
            kind: 'string',
            required: true
          },
          displayName: {
            kind: 'string',
            required: true
          }
        }
      },
      isLocked: {
        kind: 'boolean',
        required: false
      }
    }
  }
] as const satisfies ReadonlyArray<PipelineStepShape>;
